import React, { Component } from 'react';
import {
  withRouter
} from 'react-router-dom';
import {
  Page,
  Card,
  Text,
  ProgressBar,
  BlockStack,
  Badge,
  Banner,
  Button,
  Icon,
  List,
  Modal,
  InlineGrid,
  Tooltip,
  DropZone,
  Thumbnail,
  Tabs,
  Link,
  SkeletonBodyText,

} from '@shopify/polaris';
import { ArrowRightIcon, XIcon, XSmallIcon } from "@shopify/polaris-icons";
import utils from '../../../../utils/utils';

import {
  reqGetImgOptTotal,
  reqGetImageOptDataPage,
  reqGetOptSchedule,
  reqBatchReOptimize,
  reqBatchRestore,
  reqSaveSettings,
  reqStopImageOptTask,
  reqUpdateCustomerClick,
  reqSaveSwitchState,
  reqGetImageUsageStatus,
  reqGetPresignedUploadUrls,
  reqUploadImagesOpt,

} from "../../../../api"
import { PAGE_DOMAIN } from '../../../../utils/constants';
import Switch from "react-switch";
import { store } from '../../../../redux/store';
import './index.scss';
import Language from '../../../../i18n/Language';
import ManaullyModal from './components/ManuallyModal';
import OptHistoryTable from './components/OptHistoryTable';
import SkeltonLoading from "../../../../components/SkeltonLoading/index";
import QuotaGiftIcon from '../../../../assets/QuotaGiftIcon';
import { connect } from 'react-redux';
import { setImageAutoSwitchData, setSaveSwitchData } from '../../../../redux/actions/getAppPublicData';
import cloneDeep from 'lodash-es/cloneDeep';
import debounce from 'lodash-es/debounce';
import { setPageData } from '../../../../redux/actions/getAppPageData';
import FooterTrustHelp from '../../../../components/FooterTrustHelp';
import { showNewMessage } from '@intercom/messenger-js-sdk';
import ViewImage from '../../../../components/ViewImage';
const t = Language;

let timerArr = [], historyArr = [];
class indexClass extends Component {
  state = {
    //页面动作
    loading: true,
    loadingPage: true,
    LanguageRefreshData: false,
    existUser: false, // 是否存在首次设置

    showToast: false,
    showToastText: '',
    showToastIserror: '',
    // 表格条数
    current_PageSize: 5,
    current_PageSize_alt: 5,
    isShowQuotaImage: true, // 额度banner状态

    level: 1, // 等级
    switchLoading: false, // 开关loading
    auto_switch: false,
    isShowAutoState: false, // 是否展示自动状态
    FirstSetActive: false, // 首次设置弹窗状态
    isShowManuallyModal: false, // 手动弹窗状态
    firstSetSheetActive: false, // 抽屉状态

    is_default: 1, // 是否第一次设置
    total_saved_size: 0, // 比特单位
    avg_saved_space: 0,
    avg_saved_percent: 0,
    total_original_size: 0,
    total_compress_size: 0,
    optimize_status: 0,
    un_opt_num: 0, // 待优化
    impressionsUse: 0, // 使用额度
    impressionsAll: 0, // 总额度
    impressionsProportion: 0,  // 占比额度
    freeQuota: 150,  // 免费额度

    image_opt: {}, // 基础设置
    alt_text: {}, // alt设置
    file_name: {}, // 文件名称设置

    isShowImgCompression: false, // 开关状态
    isShowImgAltText: false, // 开关状态
    isShowImgFilename: false, // 开关状态
    productImg: 0, // check状态
    ColImg: false, // check状态
    BlogImg: false, // check状态
    ConvertImg: false, // check状态
    AddWaterImg: false, // check状态
    productAlt: 0, // check状态
    ColAlt: false, // check状态
    BlogAlt: false, // check状态
    blankImgAlt: false, // check状态
    productFile: 0, // check状态
    ColFile: false, // check状态
    BlogFile: false, // check状态
    setSaveLoading: false, // 保存设置loading
    setSaveDisabled: true, // 是否禁用save
    tagSet: {},
    proAltTag: '',    // tag输入框
    colAltTag: '',
    blogAltTag: '',
    proFileTag: '',
    colFileTag: '',
    blogFileTag: '',
    productAltList: [
      {
        content: 'Product title',
        onAction: () => this.addApplyField('Product title', 'ProductAltFixTag')
      },
      {
        content: 'Product vendor',
        onAction: () => this.addApplyField('Product vendor', 'ProductAltFixTag')
      },
      {
        content: 'Product type',
        onAction: () => this.addApplyField('Product type', 'ProductAltFixTag')
      },
      {
        content: 'Price',
        onAction: () => this.addApplyField('Price', 'ProductAltFixTag')
      },
      {
        content: 'Shop name',
        onAction: () => this.addApplyField('Shop name', 'ProductAltFixTag')
      },
      {
        content: 'Product variant',
        onAction: () => this.addApplyField('Product variant', 'ProductAltFixTag')
      },
    ],
    colAltTagList: [
      {
        content: 'Collection title',
        onAction: () => this.addApplyField('Collection title', 'ColAltFixTag')
      },
      {
        content: 'Shop name',
        onAction: () => this.addApplyField('Shop name', 'ColAltFixTag')
      }
    ],
    blogAltTagList: [
      {
        content: 'Blog title',
        onAction: () => this.addApplyField('Blog title', 'BlogAltFixTag')
      },
      {
        content: 'Shop name',
        onAction: () => this.addApplyField('Shop name', 'BlogAltFixTag')
      }
    ],
    productFileList: [
      {
        content: 'Product title',
        onAction: () => this.addApplyField('Product title', 'ProductFileFixTag')
      },
      {
        content: 'Product vendor',
        onAction: () => this.addApplyField('Product vendor', 'ProductFileFixTag')
      },
      {
        content: 'Product type',
        onAction: () => this.addApplyField('Product type', 'ProductFileFixTag')
      },
      {
        content: 'Price',
        onAction: () => this.addApplyField('Price', 'ProductFileFixTag')
      },
      {
        content: 'Shop name',
        onAction: () => this.addApplyField('Shop name', 'ProductFileFixTag')
      },
      {
        content: 'Product variant',
        onAction: () => this.addApplyField('Product variant', 'ProductFileFixTag')
      },
    ],
    colFileTagList: [
      {
        content: 'Collection title',
        onAction: () => this.addApplyField('Collection title', 'ColFileFixTag')
      },
      {
        content: 'Shop name',
        onAction: () => this.addApplyField('Shop name', 'ColFileFixTag')
      }
    ],
    blogFileTagList: [
      {
        content: 'Blog title',
        onAction: () => this.addApplyField('Blog title', 'BlogFileFixTag')
      },
      {
        content: 'Shop name',
        onAction: () => this.addApplyField('Shop name', 'BlogFileFixTag')
      }
    ],

    isShowSheetLoading: true,  // sheet loading
    allTagList: {}, // 初始化tag
    manuallyTabKey: 0, // 手动列表索引
    manuallyTableData: [], // 手动优化图片列表
    manuallyTableRes: {}, // 手动列表总数据
    manuallyQueryVal: '', // 手动搜索value
    mPage: 1, // 手动页码
    mPageSize: 10, // 条数

    showImageUploadBanner: false,
    setUpdateImageWarning: null,
    uploadedFiles: null,
    fileUpload: null,
    imgButton: true,    //图片删除按钮
    imageAddWatermarkPosition: '',
    imageAddWatermarkSize: 0,
    imageAddWatermarkOpacity: 1,

    ProductAltFixTag: {}, // tag输入对象
    ColAltFixTag: {}, // --
    BlogAltFixTag: {}, // --
    ProductFileFixTag: {}, // --
    ColFileFixTag: {}, // --
    BlogFileFixTag: {}, // tag输入对象
    imageAddWatermarkImg: '', // 图片对象数据

    hPage: 1,   // 历史记录 页码
    hPageSize: 10,   // 历史记录 条数
    historyTableRes: {}, // 接口数据
    historyQueryVal: '',   // 历史记录 搜索
    historyTabKey: 0,   // 历史记录 索引
    historyTableData: [], // 表格数据
    historyTabLoading: true, // loading历史记录表
    historyTabLoadingShow: true,

    isImageCompression: false,  // 当前开关状态
    isConvertImage: false,  // 当前开关状态
    isAddWatermark: false,  // 当前开关状态
    isImageAlttext: false,  // 当前开关状态
    isImageFilename: false,   // 当前开关状态

    tagActive: [], //  是否高亮tag输入框
    ProductAltFixTagPop: false,
    ColAltFixTagPop: false,
    BlogAltFixTagPop: false,
    ProductFileFixTagPop: false,
    ColFileFixTagPop: false,
    BlogFileFixTagPop: false,

    isShowManuallyBtnLoading: false,  // 手动按钮loading
    manuallyTableState: {},
    historyTableState: {},

    progressCp: 0,      // 当前完成优化数量
    progressAll: 0,     // 需要完成总量
    isShowProgress: -1,   // 是否展示进度条
    allOptType: true,       // 是否存在任意一个
    optType: '',          // 优化类型
    optPageType: 0,
    stopLoading: false,
    prevType: '',

    restoreProId: -1,
    batchLoading: true,     // 批量操作loading
    historyyPre: false,     // 历史记录分页
    historyNext: false,
    manuallyPre: false,     // 手动分页
    manuallyNext: false,
    initStateBtn: true, // 手动按钮初始化状态
    addTagsProAlt: '',
    addTagsColAlt: '',
    addTagsBlogAlt: '',
    addTagsProFile: '',
    addTagsColFile: '',
    addTagsBlogFile: '',
    isInLoading: false,
    isLocalStorage: false,    // 是否无痕

    exceedUse: 0, // 超出额度
    exceedAll: 0, // 超出额度
    is_capped: false, // 是否可增量
    is_over_quota: false, // 是否开启
    isShowOverCharge: false, // 是否显示增量提示

    questionList: {
      w_image: {
        title: "What is image optimization?",
        tag: ["SEOWILL's image optimization involves techniques such as compression, editing ALT tags, using appropriate file formats, etc., to reduce image file size, improve page loading speed, and optimize SEO search."]
      },
      why_bimage: {
        title: "Why is image optimization necessary?",
        tag: ["Optimizing images can enhance website loading speed, reduce bandwidth consumption, and improve user experience. Websites that load quickly are generally more popular among users and receive better rankings in search engines."]
      },
      // wia_image: {
      //   title: "What is an ALT tag?",
      //   tag: ["ALT tag is an HTML attribute used to provide alternative text descriptions for images. It is used to convey the content of an image to users when the image cannot be displayed or is being read by screen readers."]
      // },
      // wwrite_bimage: {
      //   title: "Why is necessary to write ALT tags?",
      //   tag: ["ALT tags improve accessibility and SEO, describe image content, enhance user experience, and increase search engine visibility."]
      // },
      htm_image: {
        title: "How to manually optimize images?",
        tag: ["First, select the type of images you want to optimize, then click on manual optimization on the page, check the corresponding products, collections, blogs for optimization, and the corresponding results will be displayed below."]
      },
      hta_image: {
        title: "How to automatically optimize images?",
        tag: ["First, select the type of images you want to optimize, then turn on the automatic switch, SEOWILL will automatically optimize images for you 24 hours a day, detect new images automatically, and you don't need to take any further action."]
      },
      his_image: {
        title: "How long are images saved?",
        tag: ["Images optimized by SEOWILL are saved in the SEOWILL system for 30 days, during which you can perform operations such as restoration and re-optimization. If you uninstall SEOWILL, the images will not be restored in Shopify, where images are saved permanently."]
      },
      after_image: {
        title: "[Precautions] After image optimization, your images will have a new URL.",
        tag: ["For image optimization, if only compression is applied, we won't generate a new filename. However, if you choose to modify the filename or add a watermark, the system requires a unique filename; otherwise, Shopify will create a random string. Therefore, after image optimization, a new URL will be generated. To avoid issues, please update the image links used on other platforms accordingly."]
        // tag: ["For image optimization, a unique file name is required, otherwise Shopify will create a random string. Therefore, after image optimization, a new URL will be generated. To avoid issues, please modify the image links used by other platforms."]
      },
      wtype_image: {
        title: "What types of images can we optimize?",
        tag: ["SEOWILL can automatically compress product, collection, and blog post feature images, but does not support optimization of content images and homepage carousel images. If you need optimization for these, you will need to manually optimize the images before uploading."]
      },
      will_image: {
        title: "Will it detect new images?",
        tag: ["SEOWILL automatically optimizes new product, collection, and blog folder images upon upload. No additional action is required."]
      },
      can_image: {
        title: "How can I restore the original images?",
        tag: ["Select the image from the list, click on the restore button, and the system will restore the image to its initial state."]
      },
      wdmy_image: {
        title: "Why do my optimized images contain random numbers?",
        tag: ["Random numbers are added to the end of the file name to ensure uniqueness and avoid overwriting images with the same file name. This does not affect SEO."]
      },
    },
    isShowMaxLimitState: false,
    total_speed_increase: 0,
    isShowGetMore: true,
    isShowCwAdverImage: false,  // cw广告
    isShowUnderFunc: false,
    impressionsPro: 0,  // 进度条
    exceedPro: 0,

    isShowSecTip: false,    // 是否显示提示
    isShowPop: false,
    isGuideTip: false,
    imageSecTip: false,
    reduxLoading: true,
    remainQuota: 0,
    // 操作类型
    handleTypePro: -1,
    handleTypeCol: -1,
    handleTypeBlog: -1,
    usage_status: false,  // 图片超额状态
    selectedTab: 0,  // 当前选中tab
    allQuotaUse: 0,
    allQuotaAll: 0,
    isShowImgProgress: false,
    imgUrl: '',
    isShowAutoStateBanner: true,  // 是否展示自动状态banner
    updFiles: [],
    total_num: 0,
    rejectedUpdFiles: [],
    ActionUpdateLoading: false,
    opt_status: 2,
    shopify_status: [],
    isShowBulkReOpt: false, // 是否展示批量重新优化
    isShowFileOpt: true, // 是否展示文件名称优化
    isLimitState: false,
    isShowWarningQuotaTip: true,
    isManuallyAction: false, // 是否手动操作
    auto_opt_num: 0,
    isGetData: 0,
    adverData: this.props.adverData,
    isShowQuotaInfo: false,

  };

  callback = (val) => {
    this.setState({
      LanguageRefreshData: val
    })
  }

  UNSAFE_componentWillMount() {
    let quotaBannerImage = null;
    let isLocalStorage = null;
    let isShowGetMore = true;
    let imageSecTip = false;
    try {
      isLocalStorage = true;
      quotaBannerImage = sessionStorage.getItem('quotaBannerImage');
      isShowGetMore = !Boolean(sessionStorage.getItem('getMoreQuotaBanner'));
      imageSecTip = !Boolean(sessionStorage.getItem('imageSecTip'));
    } catch {
      quotaBannerImage = 0;
      isLocalStorage = false;
    }
    this.setState({
      isShowQuotaImage: !Boolean(Number(quotaBannerImage)),
      isLocalStorage: isLocalStorage,
      isShowGetMore,
      imageSecTip,

    })
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.adverData !== this.props.adverData) {
      this.setState({
        adverData: nextProps.adverData,
      })
    }
    return true;
  }

  //进入页面调用接口
  componentDidMount() {
    const _params = this.props.location;
    let _page = store.getState().page.pageInit;
    this.getImageOverchargeState();
    this.getProductStatistics(true, _page?.ImageOptimization);
    this.getOptSchedule();
    this.getOptHistoryTable();

    // 获取开关状态
    let _store = store.getState().public;
    let switchData = _store.publicInit.head_data?.switch_data;
    this.setState({
      isShowCwAdverImage: !Boolean(switchData?.cwAdverImageState),
      isGuideTip: Boolean(_params?.query === "showPopover"),
    })

  }

  // 获取图片超额状态
  getImageOverchargeState = async () => {
    const res = await reqGetImageUsageStatus();
    if (res.ack === 1) {
      this.setState({
        usage_status: res.data.usage_status,
      })
    }
  }

  // 获取额度及优化数据
  getOptSchedule = debounce(async (isOpen = false) => {
    let { historyTabKey } = this.state;
    let params = {
      data_type: historyTabKey + 1
    }
    const res = await reqGetOptSchedule(params);
    if (res && res.product) {
      let optTypes = historyTabKey === 0 ? res.product?.process_type : historyTabKey === 1 ? res.collection?.process_type : res.article?.process_type;
      let optPageTypes = historyTabKey === 0 ? res.product.page_type : historyTabKey === 1 ? res.collection.page_type : res.article.page_type;
      let allOptType = (!Boolean(res.product.process_result) && (res.product?.process_type === 'restore' || (res.product?.process_type === 're-Optimize' && res.product.page_type === 0)) && Boolean(res.product.opt_total)) || (!Boolean(res.collection.process_result) && (res.collection.process_type === 'restore' || (res.collection.process_type === 're-Optimize' && res.collection.page_type === 0)) && Boolean(res.collection.opt_total)) || (!Boolean(res.article.process_result) && (res.article.process_type === 'restore' || (res.article.process_type === 're-Optimize' && res.article.page_type === 0)) && Boolean(res.article.opt_total));
      let showOvercharge = Boolean(
        res.impressions_use >= res.impressions_all
        && res.impressions_all >= 6000
        && store.getState().public?.level === 3
        && Boolean(res?.is_capped)
        && res.img_usage_use >= res.img_usage_all
      )
      // 计算进度条
      let impressionsProVal = Number(100 * (res.impressions_use / res.impressions_all));
      let exceedProVal = Number(100 * (res.img_usage_use / res.img_usage_all));
      let impressionsAll = res.impressions_all;
      let impressionsUse = res.impressions_use;
      let exceedAll = res?.img_usage_all === undefined ? -1 : res.img_usage_all;
      let exceedUse = res?.img_usage_use === undefined ? -1 : res.img_usage_use;
      this.setState({
        impressionsUse,
        impressionsAll,
        exceedUse,
        exceedAll,
        exceedPro: Number((exceedProVal > 100 ? 100 : exceedProVal).toFixed(2)),
        impressionsPro: Number((impressionsProVal > 100 ? 100 : impressionsProVal).toFixed(2)),
        allQuotaUse: impressionsUse + (exceedUse !== -1 ? exceedUse : 0),
        allQuotaAll: impressionsAll + (exceedAll !== -1 ? exceedAll : 0),
        isShowImgProgress: (impressionsAll - impressionsUse <= 0) && (exceedAll - exceedUse <= 0),

        is_capped: Boolean(res?.is_capped),
        is_over_quota: Boolean(res?.is_over_quota),
        impressionsProportion: res.impressions_all === 0 ? 0 : (res.impressions_use / res.impressions_all) * 100,
        optType: optTypes,
        prevType: optTypes,
        optPageType: optPageTypes,
        allOptType: allOptType,

        isShowOverCharge: showOvercharge && !Boolean(res?.is_over_quota),
        isShowMaxLimitState: showOvercharge && Boolean(res?.is_over_quota) && res.img_usage_use > 0 && res.is_excess_limit,
        remainQuota: ((impressionsAll - impressionsUse) + (exceedAll - exceedUse)) > 0 ? ((impressionsAll - impressionsUse) + (exceedAll - exceedUse)) : 0,
        handleTypePro: Number(res.product.handle_type || -1),
        handleTypeCol: Number(res.collection.handle_type || -1),
        handleTypeBlog: Number(res.article.handle_type || -1),
        restoreProId: -1,
        isLimitState: (impressionsUse >= impressionsAll) && (exceedUse >= exceedAll),
        isShowQuotaInfo: true,
      }, () => {
        let optIn = historyTabKey === 0 ? Number(res.product?.opt_in || 0) : historyTabKey === 1 ? Number(res.collection?.opt_in || 0) : Number(res.article?.opt_in || 0);
        let total = historyTabKey === 0 ? Number(res.product?.opt_total || 0) : historyTabKey === 1 ? Number(res.collection?.opt_total || 0) : Number(res.article?.opt_total || 0);
        let result = historyTabKey === 0 ? Number(res.product?.process_result || 0) : historyTabKey === 1 ? Number(res.collection?.process_result || 0) : Number(res.article?.process_result || 0);

        if (total && result === 1) {
          // 判断是否该提示完成
          let opt_type = historyTabKey === 0 ? 'products images' : historyTabKey === 1 ? 'collections' : historyTabKey === 2 ? 'blogs' : 'others';
          this.props.toggleToast(`${total} ${t(opt_type)} ${t(optTypes === 'restore' ? 'restored' : 'optimized')}`, false);
          this.deleteTimeFunc();
          this.setState({
            isShowManuallyBtnLoading: false,
            isInLoading: false,
            isShowProgress: -1,
            optType: '',
            progressCp: 0,
            progressAll: 0,
            initStateBtn: false,
            allOptType: false,
          }, () => {
            setTimeout(() => {
              this.deleteTimeFunc();
              this.getOptHistoryTable(true, true);
              this.getManuallyData(false);
              this.deleteTimeFunc();
            }, 3000);
          })
        } else if (total > 0) {
          this.setState({
            isShowManuallyBtnLoading: true,
            isShowProgress: historyTabKey,
            progressCp: total - optIn,
            progressAll: total,
          })
          // 判断是否该轮询
          if (timerArr.length === 0) {
            let timer = setInterval(() => {
              this.getOptSchedule();
            }, 6000);
            timerArr.push(timer)
          }
        } else {
          let isShowState = Boolean((Number(res.product.opt_total) > 0 && Number(res.product.process_result) !== 1) || (Number(res.collection.opt_total) > 0 && Number(res.collection.process_result) !== 1) || (Number(res.article.opt_total) > 0 && Number(res.article.process_result) !== 1))
          this.setState({
            isShowProgress: -1,
            initStateBtn: false,
            isShowManuallyBtnLoading: isShowState,
            isInLoading: false,
          })
        }

        // 判断是否增量提示
        if (this.state.isShowOverCharge) {
          window.scrollTo(0, 0);
          this.changeBannerBackground(0); // 进行banner背景闪烁
        }

        if (isOpen) {
          this.openManuallyOpt();
        }
      })
    } else {
      this.props.toggleToast(res?.msg || t("Try again later"));
    }
  }, 500)

  // 切换背景
  changeBannerBackground = (nums) => {
    if (nums !== 2) {
      let objs = document.querySelector('div.overChargeBanner > div > div > div > div:nth-child(1)');
      if (objs) {
        setTimeout(() => {
          if (objs) {
            objs.style.background = '#ffd79d';
            setTimeout(() => {
              objs.style.background = '#ffb800';
              this.changeBannerBackground(nums + 1);
            }, 300)
          }
        }, 300)
      } else {
        setTimeout(() => {
          this.changeBannerBackground(0);
        }, 500)
      }
    }
  }

  // 删除订阅器
  deleteTimeFunc = () => {
    timerArr.map(timer => {
      clearInterval(timer);
      timerArr.pop();
      return false;
    })
  }

  // 设置tag
  setDefaultTag = () => {
    let { proAltTag, colAltTag, blogAltTag, proFileTag, colFileTag, blogFileTag, productAltList, colAltTagList, blogAltTagList, productFileList, colFileTagList, blogFileTagList } = this.state;
    let allTagList = {
      proAltTag: Boolean(proAltTag) ? proAltTag : `[[{"value":"${productAltList[0]['content']}"}]] - [[{"value":"${productAltList[4]['content']}"}]]`, // product
      colAltTag: Boolean(colAltTag) ? colAltTag : `[[{"value":"${colAltTagList[0]['content']}"}]] - [[{"value":"${colAltTagList[1]['content']}"}]]`, // collection
      blogAltTag: Boolean(blogAltTag) ? blogAltTag : `[[{"value":"${blogAltTagList[0]['content']}"}]] - [[{"value":"${blogAltTagList[1]['content']}"}]]`, // blog
      proFileTag: Boolean(proFileTag) ? proFileTag : `[[{"value":"${productFileList[0]['content']}"}]] - [[{"value":"${productFileList[4]['content']}"}]]`, // product
      colFileTag: Boolean(colFileTag) ? colFileTag : `[[{"value":"${colFileTagList[0]['content']}"}]] - [[{"value":"${colFileTagList[1]['content']}"}]]`, // collection
      blogFileTag: Boolean(blogFileTag) ? blogFileTag : `[[{"value":"${blogFileTagList[0]['content']}"}]] - [[{"value":"${blogFileTagList[1]['content']}"}]]`, // blog
    }
    this.setState({
      proAltTag: allTagList['proAltTag'],
      colAltTag: allTagList['colAltTag'],
      blogAltTag: allTagList['blogAltTag'],
      proFileTag: allTagList['proFileTag'],
      colFileTag: allTagList['colFileTag'],
      blogFileTag: allTagList['blogFileTag'],
      allTagList,
    })
  }

  // 转成tag输入框的数据格式
  setDefaultTagFormat = (type, data) => {
    let val = "";
    if (Boolean(data) && data !== '') {
      val = cloneDeep(data);
      val = val.replace(/\n/g, '');
      if (type === 'product') {
        val = val.replace(/%product_title%/g, '[[{"value":"Product title"}]]')
          .replace(/%product_vendor%/g, '[[{"value":"Product vendor"}]]')
          .replace(/%product_type%/g, '[[{"value":"Product type"}]]')
          .replace(/%shop_name%/g, '[[{"value":"Shop name"}]]')
          .replace(/%price%/g, '[[{"value":"Price"}]]')
          .replace(/%product_variant%/g, '[[{"value":"Product variant"}]]');
      } else if (type === 'collection') {
        val = val.replace(/%collection_title%/g, '[[{"value":"Collection title"}]]')
          .replace(/%shop_name%/g, '[[{"value":"Shop name"}]]');
      } else if (type === 'blog') {
        val = val.replace(/%blog_title%/g, '[[{"value":"Blog title"}]]')
          .replace(/%shop_name%/g, '[[{"value":"Shop name"}]]');
      } else { }
    }

    return val;
  }

  // 获取产品页面统计数据
  getProductStatistics = async (isGetTable = true, _reduxData = null) => {
    let res = {};
    if (_reduxData) {
      res = _reduxData;
    } else {
      res = await reqGetImgOptTotal();
    }
    if (res.ack === 1) {
      if (_reduxData) {
        this.getProductStatistics(true, null);
      }
      this.props.getPageDataRedux(res);
      let t = res.total;
      let set = res.settings;
      let first = res.settings.is_default;
      // 计算进度条
      let impressionsProVal = Number(100 * (res.opt_schedule.impressions_use / res.opt_schedule.impressions_all));
      let exceedProVal = Number(100 * (res.opt_schedule?.img_usage_use / res.opt_schedule?.img_usage_all));
      let impressionsAll = res.opt_schedule.impressions_all;
      let impressionsUse = res.opt_schedule.impressions_use;
      let exceedAll = res.opt_schedule?.img_usage_all === undefined ? -1 : res.opt_schedule.img_usage_all;
      let exceedUse = res.opt_schedule?.img_usage_use === undefined ? -1 : res.opt_schedule.img_usage_use;
      this.setState({
        total_saved_size: changeBitInfo(t.total_saved_size),
        avg_saved_space: changeBitInfo(t.avg_saved_space),
        total_speed_increase: this.changeSaveTime(t.total_saved_size),
        avg_saved_percent: Number(t.total_original_size) === 0 ? 0 : Number(((Number(t.total_saved_size) / Number(t.total_original_size)) * 100).toFixed(2)),
        total_original_size: Number(t.total_original_size),
        total_compress_size: Number(t.total_compress_size),
        total_num: Number(t.total_num),
        un_opt_num: Number(t.un_opt_num),
        optimize_status: 0,
        is_default: first, // 是否第一次设置
        FirstSetActive: res.settings.is_default === 1,
        // firstSetSheetActive: res.settings.is_default === 1 ? true : false, // 第一次设置默认弹出
        impressionsUse,
        impressionsAll,
        exceedUse,
        exceedAll,
        isLimitState: (impressionsUse >= impressionsAll) && (exceedUse >= exceedAll),
        auto_opt_num: Number(res.total?.opt_job_num || 0),
        exceedPro: Number((exceedProVal > 100 ? 100 : exceedProVal).toFixed(2)),
        impressionsPro: Number((impressionsProVal > 100 ? 100 : impressionsProVal).toFixed(2)),
        is_capped: Boolean(res.opt_schedule?.is_capped),
        is_over_quota: Boolean(res.opt_schedule?.is_over_quota),

        auto_switch: Boolean(res.settings.auto_switch), // 自动状态
        isShowAutoState: Boolean(res.settings.auto_switch), // 自动开关状态
        // 设置
        image_opt: set.image_opt,
        alt_text: set.alt_text,
        file_name: set.file_name,

        isShowImgCompression: Boolean(set.image_opt?.switch), // 开关状态
        isShowImgAltText: Boolean(set.alt_text?.switch), // 开关状态
        isShowImgFilename: Boolean(set.file_name?.switch), // 开关状态
        productImg: set.image_opt?.product,
        ColImg: Boolean(set.image_opt?.collection),
        BlogImg: Boolean(set.image_opt?.blogs),
        ConvertImg: Boolean(set.image_opt?.pngtojpg),
        AddWaterImg: Boolean(set.image_opt?.watermark?.switch),
        imageAddWatermarkPosition: set.image_opt?.watermark?.position,  // 水印参数
        imageAddWatermarkSize: Number(set.image_opt?.watermark?.image_height) * 100,
        imageAddWatermarkOpacity: set.image_opt?.watermark?.opacity,
        imageAddWatermarkImg: set.image_opt?.watermark?.logo,
        productAlt: set.alt_text?.product,
        ColAlt: Boolean(set.alt_text?.collection),
        BlogAlt: Boolean(set.alt_text?.blogs),
        blankImgAlt: Boolean(set.alt_text?.blank_replace),
        productFile: set.file_name?.product,
        ColFile: Boolean(set.file_name?.collection),
        BlogFile: Boolean(set.file_name?.blogs),
        proAltTag: this.setDefaultTagFormat('product', set.alt_text?.product_rule),
        colAltTag: this.setDefaultTagFormat('collection', set.alt_text?.collection_rule),
        blogAltTag: this.setDefaultTagFormat('blog', set.alt_text?.blogs_rule),
        proFileTag: this.setDefaultTagFormat('product', set.file_name?.product_rule),
        colFileTag: this.setDefaultTagFormat('collection', set.file_name?.collection_rule),
        blogFileTag: this.setDefaultTagFormat('blog', set.file_name?.blogs_rule),

        // isShowManuallyBtnLoading: res.opt_schedule.opt_total > 0 && res.opt_schedule.process_result !== 1 ? true : false,
        isShowOverCharge: Boolean(res.opt_schedule.impressions_use >= res.opt_schedule.impressions_all && res.opt_schedule.impressions_all >= 6000 && store.getState().public?.level === 3 && Boolean(res.opt_schedule?.is_capped) && !Boolean(res.opt_schedule?.is_over_quota) && res.opt_schedule.img_usage_use >= res.opt_schedule.img_usage_all),

        level: store.getState().public?.level,
        loadingPage: false,
        reduxLoading: Boolean(_reduxData),
        historyTabLoadingShow: Boolean(_reduxData) ? false : this.state.historyTabLoadingShow,
        remainQuota: ((impressionsAll - impressionsUse) + (exceedAll - exceedUse)) > 0 ? ((impressionsAll - impressionsUse) + (exceedAll - exceedUse)) : 0,
        handleTypePro: Number(res.opt_schedule.product.handle_type || -1),
        handleTypeCol: Number(res.opt_schedule.collection.handle_type || -1),
        handleTypeBlog: Number(res.opt_schedule.article.handle_type || -1),

        isShowFileOpt: Boolean(res.settings?.show_opt_file_name),
      }, () => {
        this.setSwitchState()
        this.props.setImageAutoSwitch({ type: 'imageOptAuto', value: Boolean(res.settings.auto_switch) })
        this.handleDropImage(0, '', set.image_opt?.watermark?.logo);
        // if (first === 0 && isGetTable && !Boolean(_reduxData) && !res.settings.auto_switch) {
        //   // 判断是否请求优化历史记录表格数据
        //   this.getOptHistoryTable();
        // } else {
        // this.setState({
        //   historyTabLoadingShow: false
        // }, () => {
        // })
        // 动画过渡
        setTimeout(() => {
          this.setState({ isShowPop: true })
        }, 200)
        // }

        if (res.settings.auto_switch) {
          this.handleAutoOptAction();
        }

        // 判断是否增量提示
        if (this.state.isShowOverCharge) {
          window.scrollTo(0, 0);
          this.changeBannerBackground(0); // 进行banner背景闪烁
        }
      })
    } else {
      this.props.toggleToast(res.message, true);
    }
  }

  // 轮询
  handleAutoOptAction = () => {
    if (historyArr.length === 0) {
      let timer = setInterval(() => {
        this.getProductStatistics();
        this.getOptHistoryTable(false);
      }, 5000)
      historyArr.push(timer)
    }
  }

  // 获取历史记录数据
  getOptHistoryTable = debounce((isLoading = true, isEndTip = false) => {
    let { hPage, hPageSize, historyTabKey, historyQueryVal, is_default, prevType, isShowAutoState, isGetData } = this.state;
    if (is_default === 1) {
      this.setState({
        historyTabLoading: false,
        historyTabLoadingShow: false,
      })
    }
    this.setState({
      historyTabLoading: Boolean(isShowAutoState && isGetData > 0) ? false : isLoading,
    }, async () => {
      let params = {
        page: hPage,
        pageSize: hPageSize,
        title: historyQueryVal,
        data_type: historyTabKey + 1,
        page_type: 0, // 历史记录
        handle_type: 2,
      }
      const res = await reqGetImageOptDataPage(params);
      if (res.ack === 1) {
        let listData = cloneDeep(res.data.data);
        listData.forEach(item => {
          item['restoreLoadingId'] = [];
          item['downloadLoadingId'] = [];
          if (historyTabKey === 0 && Boolean(item?.is_delete)) {
            item['disabled'] = true;
          } else if ([1, 2].includes(historyTabKey) && (Boolean(item?.is_delete) || Boolean(item.image?.is_overdue))) {
            item['disabled'] = true;
          } else if (historyTabKey === 3 && (Boolean(item?.is_delete) || Boolean(item?.is_overdue))) {
            item['disabled'] = true;
          } else {
            item['disabled'] = false;
          }
        })
        this.setState({
          isShowBulkReOpt: (prevType.toLowerCase()).includes('optimize') && isEndTip,
          historyTableRes: res.data,
          historyTableData: listData,
          isGetData: 1,
          historyyPre: res.data.current_page === 1 ? false : true, // 是否存在上一页状态
          historyNext: res.data.current_page >= Math.ceil(res.data.total / res.data.per_page) ? false : true, // 是否存在下一页状态
        })
      } else {
        this.props.toggleToast(res.msg, true);
      }

      this.setState({
        historyTabLoading: false,
        batchLoading: false,
        historyTabLoadingShow: false,
      }, () => {

        // 动画过渡
        setTimeout(() => {
          this.setState({ isShowPop: true })
        }, 200)
      })
    })
  }, 500)

  // 时间转换
  changeSaveTime = (limit) => {
    let time = Number((Number((limit / 2621440).toFixed(1)) * 0.1).toFixed(1));
    let formatTime;
    if (time < 60) {
      formatTime = `${time}s`;
    } else if (time < 3600) {
      let minutes = Math.floor(time / 60);
      let seconds = (time % 60).toFixed(1);
      formatTime = `${minutes.toFixed(0)}m ${seconds}s`;
    } else {
      let hours = Math.floor(time / 3600);
      let minutes = Math.floor((time % 3600) / 60);
      let seconds = (time % 60).toFixed(1);
      formatTime = `${hours}h ${minutes.toFixed(0)}m ${seconds}s`;
    }
    return formatTime;
  }

  // 自动开关事件
  autoOptAction = () => {
    let { auto_switch, is_default } = this.state;
    if (is_default === 1) {
      // 直接跳转设置页
      this.openSettingCard(1)
      // this.setState({
      //   FirstSetActive: true,
      // })
    } else {
      this.setState({
        auto_switch: !auto_switch,
        switchLoading: true,
      }, async () => {
        this.saveSetData('switch').then(res => {
          if (res.ack === 1) {
            this.setState({
              isShowAutoState: !auto_switch,
              switchLoading: false,
              setSaveLoading: false,
              imageSecTip: false,
            }, () => {
              this.props.setImageAutoSwitch(!Boolean(auto_switch))
              if (!Boolean(auto_switch)) {
                this.handleAutoOptAction();
              }
              if (Boolean(auto_switch)) {
                this.clearHistoryArr()
              } else {
                let { isGuideTip } = this.state;
                if (isGuideTip) {
                  try {
                    sessionStorage.setItem("imageSecTip", "close");
                  } catch (e) { }
                }
              }
            })
          } else {
            this.setState({
              switchLoading: false,
              auto_switch: auto_switch,
              setSaveLoading: false,
            })
          }
        });
      })
    }
  }

  // 清除历史记录定时器
  clearHistoryArr = () => {
    historyArr.map(timer => {
      clearInterval(timer);
      historyArr.pop();
      return false;
    })
  }

  // 打开首次设置窗体
  openFirstSetUp = () => {
    this.setState({
      FirstSetActive: false,
    }, () => {
      this.openSettingCard(2)
    })
  }

  // 打开手动设置
  openManuallyOpt = () => {
    this.getManuallyData();
    // let { impressionsUse, impressionsAll, exceedUse, exceedAll, level, usage_status } = this.state;
    // if ((impressionsUse < impressionsAll) || (exceedUse < exceedAll) || usage_status === true) {
    //   this.setState({
    //     isShowManuallyModal: true,
    //     isShowManuallyLoading: true,
    //   }, () => {
    //     this.getManuallyData();
    //   })
    // } else {
    //   // 判断是否超额弹窗
    //   if (level !== 1 && [30002, 30003, 40002].includes(usage_status)) {
    //     if ([40002].includes(usage_status)) {
    //       this.props.openUpdateLimit();
    //     } else {
    //       this.setState({
    //         overchargeState: true,
    //       })
    //     }
    //   } else {
    //     this.props.handleShowGetMoreUsageModal('image', (impressionsUse + exceedUse));
    //   }
    // }
  }

  // 搜索
  setQueryValue = (val) => {
    this.setState({
      queryValue: val
    })
  }

  // 打开设置面板
  openSettingCard = (type) => {
    let { isGuideTip } = this.state;
    utils.routeJump(this, '/speedOpt/PageSpeed/settings', null, isGuideTip ? 'showPopover' : '')
  }
  // openSettingCard = (type) => {
  //   let { is_default, image_opt } = this.state;
  //   if (is_default === 1 && type === 1) {
  //     // 第一次设置弹窗
  //     this.setState({
  //       FirstSetActive: true,
  //       setSaveDisabled: false,
  //     })
  //   } else {
  //     // 后续设置抽屉
  //     this.setState({
  //       firstSetSheetActive: true,
  //     }, () => {
  //       if(is_default === 1) {
  //         this.setState({
  //           setSaveDisabled: false,
  //         })
  //       }
  //       this.handleDropImage(0, '', image_opt?.watermark?.logo);
  //       this.setDefaultTag();
  //     })
  //   }

  //   // 过渡数据渲染时间
  //   setTimeout(() => {
  //     this.setState({
  //       isShowSheetLoading: false,
  //     })
  //   }, 500)
  // }

  // 打开设置
  openSetupBox = () => {
    this.setState({
      isShowManuallyModal: false,
    }, () => {
      this.openFirstSetUp(2);
    })
  }

  // 单个优化
  handleOptimize = (data) => {
    let { isLimitState, usage_status } = this.state;
    if (isLimitState && usage_status !== true) {
      this.handleUpgradeModeSet();
    } else {
      this.setState({
        isShowManuallyModal: false,
        isInLoading: true,
        manuallyQueryVal: '',
        isShowManuallyBtnLoading: true,
        manuallyTableState: data,
      }, () => {
        this.optImageData();
      })
    }
  }

  // 批量操作手动列表数据
  handleOptManaully = () => {
    let { isLimitState, usage_status } = this.state;
    if (isLimitState && usage_status !== true) {
      this.handleUpgradeModeSet();
    } else {
      this.setState({
        isShowManuallyModal: false,
        isInLoading: true,
        manuallyQueryVal: '',
        isShowManuallyBtnLoading: true,
      }, () => {
        this.optImageData();
      })
    }
  }

  // 发起图片优化
  optImageData = () => {
    let { manuallyTabKey, manuallyTableState, opt_status, shopify_status } = this.state;
    let dataIdList = [];
    manuallyTableState[0].forEach(item => {
      dataIdList.push({
        data_id: item
      })
    })
    this.setState({
      historyTabKey: manuallyTabKey,
      isShowProgress: manuallyTabKey,
      optType: '',
    }, async () => {
      let params = {
        data_type: manuallyTabKey + 1,
        data_list: dataIdList,
        re_opt_type: manuallyTableState[1] ? 'all' : '',
        page_type: 1,
        handle_type: 2,
      }
      if (opt_status) {
        params.opt_status = opt_status;
      }
      if (manuallyTabKey === 0) {
        if (shopify_status && shopify_status?.length > 0) {
          params.shopify_status = shopify_status;
        }
      }
      this.getOptHistoryTable();
      const res = await reqBatchReOptimize(params);
      if (res.ack === 1) {
        this.setState({
          isManuallyAction: true,
        }, () => {
          // 重新请求手动列表数据
          this.getManuallyData(false);
          setTimeout(() => {
            this.getOptSchedule();
          }, 3000)
        })
      } else {
        this.props.toggleToast(res.msg, true);
      }
    })
  }

  // 打开上传图片
  openUploadModal = () => {
    this.$uploadEvent.openUploadModal();
  }

  // 获取上传组件事件
  getEventAction = (e) => {
    this.$uploadEvent = e;
  }

  // 状态切换 正负
  handleStateChange = (name, val) => {
    this.setState({
      [name]: val,
    })

    // 首次设置
    if (name === 'firstSetSheetActive') {
      setTimeout(() => {
        this.setState({
          isShowSheetLoading: true,
        })
      }, 300)
    }

    // 抽屉弹窗
    if (['isShowImgCompression', 'isShowImgAltText', 'isShowImgFilename'].includes(name)) {
      this.setState({
        setSaveDisabled: false,
      })
    }

    // 手动弹窗
    if (name === 'isShowManuallyModal') {
      this.setState({
        mPage: 1,
        mPageSize: 10,
        manuallyTabKey: 0,
        manuallyQueryVal: '',
      })
    }
  }

  // 设置 check
  changeCheckState = (val, name) => {
    this.setState({
      setSaveDisabled: false,
    }, () => {
      if (name.indexOf('product') > -1) {
        let names = name.split('-')[0];
        this.setState({
          [names]: !Boolean(val) ? 0 : (name.indexOf('One') > -1 && Boolean(val)) ? 1 : 2,
        })
      } else if (name === 'ConvertImg_item') {
        this.setState({
          ConvertImg: Boolean(val)
        })
      } else if (name === 'AddWaterImg') {
        this.setState({
          showImageUploadBanner: val,
          [name]: Boolean(val)
        }, () => {
          if (!Boolean(val)) {
            this.deleteImage();
            this.setState({
              imageAddWatermarkImg: ''
            })
          }
        })
      } else {
        this.setState({
          [name]: Boolean(val)
        })
      }
    })
  }

  // 选择对应字段
  addApplyField = (type, name) => {
    let { proAltTag, colAltTag, blogAltTag, proFileTag, colFileTag, blogFileTag } = this.state;
    // 删除对应提示
    let curActive = cloneDeep(this.state.tagActive);
    if (curActive.includes(name)) {
      curActive.splice(curActive.indexOf(name), 1);
    }
    // 对象赋值
    let setObj =
      name === 'ProductAltFixTag' ? {
        proAltTag: !Boolean(proAltTag?.length) ? `[[{"value":"${type}"}]]` : `${proAltTag} [[{"value":"${type}"}]]`,
        addTagsProAlt: !Boolean(proAltTag?.length) ? `[[{"value":"${type}"}]]` : `${proAltTag} [[{"value":"${type}"}]]`
      } :
        name === 'ColAltFixTag' ? {
          colAltTag: !Boolean(colAltTag?.length) ? `[[{"value":"${type}"}]]` : `${colAltTag} [[{"value":"${type}"}]]`,
          addTagsColAlt: !Boolean(colAltTag?.length) ? `[[{"value":"${type}"}]]` : `${colAltTag} [[{"value":"${type}"}]]`,
        } :
          name === 'BlogAltFixTag' ? {
            blogAltTag: !Boolean(blogAltTag?.length) ? `[[{"value":"${type}"}]]` : `${blogAltTag} [[{"value":"${type}"}]]`,
            addTagsBlogAlt: !Boolean(blogAltTag?.length) ? `[[{"value":"${type}"}]]` : `${blogAltTag} [[{"value":"${type}"}]]`,
          } :
            name === 'ProductFileFixTag' ? {
              proFileTag: !Boolean(proFileTag?.length) ? `[[{"value":"${type}"}]]` : `${proFileTag} [[{"value":"${type}"}]]`,
              addTagsProFile: !Boolean(proFileTag?.length) ? `[[{"value":"${type}"}]]` : `${proFileTag} [[{"value":"${type}"}]]`,
            } :
              name === 'ColFileFixTag' ? {
                colFileTag: !Boolean(colFileTag?.length) ? `[[{"value":"${type}"}]]` : `${colFileTag} [[{"value":"${type}"}]]`,
                addTagsColFile: !Boolean(colFileTag?.length) ? `[[{"value":"${type}"}]]` : `${colFileTag} [[{"value":"${type}"}]]`,
              } :
                name === 'BlogFileFixTag' ? {
                  blogFileTag: !Boolean(blogFileTag?.length) ? `[[{"value":"${type}"}]]` : `${blogFileTag} [[{"value":"${type}"}]]`,
                  addTagsBlogFile: !Boolean(blogFileTag?.length) ? `[[{"value":"${type}"}]]` : `${blogFileTag} [[{"value":"${type}"}]]`,
                } : {};

    setObj[`${name}Pop`] = !Boolean(this.state[`${name}Pop`]);
    setObj['tagActive'] = curActive;
    setObj['setSaveDisabled'] = false;
    this.setState(setObj);
  }

  // 获取tag输入框对象
  setTagifyData = (data, name) => {
    this.setState({
      [name]: data[0],
    })
    this.$name = data[1];
  }

  // 输入
  tagInputData = debounce((e, name) => {
    let curActive = cloneDeep(this.state.tagActive);
    const tagCompare = {
      proAltTag: "ProductAltFixTag",
      colAltTag: "ColAltFixTag",
      blogAltTag: "BlogAltFixTag",
      proFileTag: "ProductFileFixTag",
      colFileTag: "ColFileFixTag",
      blogFileTag: "BlogFileFixTag",
    }
    if (curActive.includes(tagCompare[name])) {
      curActive.splice(curActive.indexOf(tagCompare[name]), 1);
    }
    let value = "";
    if (e.type === "input") {
      value = e.detail.textContent;
      if (e.detail.tagify.value.length > 0) {
        e.detail.tagify.value.forEach(item => {
          value = value.replace(new RegExp(`([^"])${item.value}([^"])`, 'g'), `$1[[{"value":"${item.value}"}]]$2`)
        })
      }
    } else {
      value = e.detail?.value;
      if (e.type === "remove") {
        value = e.detail.tagify.state.lastOriginalValueReported;
      }
    }
    this.setState({
      [name]: Boolean(value) ? value.replace(/[\n\u200B]/g, "") : '',
      tagActive: curActive,
      setSaveDisabled: false,
    })
  }, 100)

  // 无痕模式 - 输入
  tagInputDataTraceless = (val, name) => {
    let curActive = cloneDeep(this.state.tagActive);
    const tagCompare = {
      proAltTag: "ProductAltFixTag",
      colAltTag: "ColAltFixTag",
      blogAltTag: "BlogAltFixTag",
      proFileTag: "ProductFileFixTag",
      colFileTag: "ColFileFixTag",
      blogFileTag: "BlogFileFixTag",
    }
    if (curActive.includes(tagCompare[name])) {
      curActive.splice(curActive.indexOf(tagCompare[name]), 1);
    }
    let tagType = ['proAltTag', 'proFileTag'].includes(name) ? 'product' : ['colAltTag', 'colFileTag'].includes(name) ? 'collection' : 'blog';
    let tagVal = this.setDefaultTagFormat(tagType, val);
    this.setState({
      [name]: Boolean(tagVal) ? tagVal.replace(/[\n\u200B]/g, "") : '',
      tagActive: curActive,
      setSaveDisabled: false,
    })
  }

  // 改变tag下拉框状态
  changeSelectPop = (id) => {
    let name = `${id}Pop`;
    const tagState = {
      ProductAltFixTagPop: false,
      ColAltFixTagPop: false,
      BlogAltFixTagPop: false,
      ProductFileFixTagPop: false,
      ColFileFixTagPop: false,
      BlogFileFixTagPop: false,
    }
    tagState[name] = !Boolean(this.state[name]);
    this.setState(tagState);
  }

  // 格式化tag数据
  changeTagFormat = (type, data) => {
    let val = cloneDeep(data);
    val = val.replace(/\n/g, '');
    if (type === 'product') {
      val = val.replace(/\[\[{"value":"Product title"}\]\]/g, '%product_title%')
        .replace(/\[\[{"value":"Product vendor"}\]\]/g, '%product_vendor%')
        .replace(/\[\[{"value":"Product type"}\]\]/g, '%product_type%')
        .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shop_name%')
        .replace(/\[\[{"value":"Price"}\]\]/g, '%price%')
        .replace(/\[\[{"value":"Product variant"}\]\]/g, '%product_variant%');
    } else if (type === 'collection') {
      val = val.replace(/\[\[{"value":"Collection title"}\]\]/g, '%collection_title%')
        .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shop_name%');
    } else if (type === 'blog') {
      val = val.replace(/\[\[{"value":"Blog title"}\]\]/g, '%blog_title%')
        .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shop_name%');
    } else { }

    return val;
  }

  // 改版手动tab
  changeManuallyTab = (e) => {
    this.setState({
      manuallyTabKey: e,
      manuallyTableData: [],
      mPage: 1,
      mPageSize: 10,
      isShowManuallyLoading: true,
      manuallyQueryVal: '',
      shopify_status: [],
      opt_status: 2,
    }, () => {
      this.getManuallyData();
    })
  }

  // 手动弹窗搜索
  changeManuallyQueryVal = (val) => {
    this.setState({
      manuallyQueryVal: val,
    }, () => {
      this.getManuallyData();
    })
  }

  // 手动 分页
  changeManuallyPageData = (s) => {
    this.setState({
      mPage: Number(s),
      isShowManuallyLoading: true,
    }, () => {
      this.getManuallyData();
    })
  }

  // 手动 页数
  changeManuallyPageSizeData = (s) => {
    this.setState({
      mPage: 1,
      mPageSize: Number(s),
      isShowManuallyLoading: true,
    }, () => {
      this.getManuallyData();
    })
  }

  // 手动 页码 失去焦点
  handleManuallyPageBlur = (e) => {
    this.setState({
      mPage: Number(e),
    }, () => {
      this.getManuallyData();
    })
  }

  // 获取手动列表数据
  getManuallyData = debounce(async (isLoading = true) => {
    let { mPage, mPageSize, manuallyTabKey, manuallyQueryVal, is_default, opt_status, shopify_status } = this.state;
    let curSwitchState = this.setSwitchState(manuallyTabKey);
    if (is_default === 1 || !curSwitchState) {
      this.setState({
        isShowManuallyLoading: false,
      })
      return false
    } else {
      this.setState({
        isShowManuallyLoading: isLoading,
      })
      let params = {
        page: mPage,
        pageSize: mPageSize,
        title: manuallyQueryVal,
        data_type: manuallyTabKey + 1,
        page_type: 1,
        opt_status: opt_status, // 默认获取未优化数据
      }
      if (manuallyTabKey === 0) {
        params.shopify_status = shopify_status;
      }
      const res = await reqGetImageOptDataPage(params);
      if (res.ack === 1) {
        let list = cloneDeep(res.data);
        list['data'].forEach(item => {
          item['id'] = manuallyTabKey === 0 ? item['prod_id'] : manuallyTabKey === 1 ? item['coll_id'] : item['art_id'];
        })
        this.setState({
          manuallyTableRes: list,
          manuallyTableData: list.data,
          manuallyPre: res.data.current_page === 1 ? false : true, // 是否存在上一页状态
          manuallyNext: res.data.current_page >= Math.ceil(res.data.total / res.data.per_page) ? false : true, // 是否存在下一页状态
        })
      } else {
        this.props.toggleToast(res.msg, true);
      }

      this.setState({
        isShowManuallyLoading: false,
      })
    }
  }, 500)

  // 设置手动设置的开关状态
  setSwitchState = () => {
    // 增加判断是否开启对应配置
    let { image_opt, alt_text, file_name } = this.state;
    let isImageCompression = Boolean(image_opt?.switch);
    let isConvertImage = Boolean(image_opt.pngtojpg);
    let isAddWatermark = Boolean(image_opt.watermark?.switch);
    let isImageAlttext = Boolean(alt_text?.switch);
    let isImageFilename = Boolean(file_name?.switch);
    this.setState({
      isImageCompression,
      isConvertImage,
      isAddWatermark,
      isImageAlttext,
      isImageFilename,
    })

    return isImageCompression || isConvertImage || isAddWatermark || isImageAlttext || isImageFilename;
  }

  //拖动条
  handleRangeSliderChange = (value, name) => {
    this.setState({
      [name]: value,
      setSaveDisabled: false,
    });
  }

  //上传图片
  updateImageDrop = (files, acceptedFiles, rejectedFiles) => {
    this.setState({
      files: acceptedFiles[0],
      loadingLogo: true,
    }, () => {
      // 大于500kb提示
      if (files[0].type.indexOf('image') === -1 || files[0].type.indexOf('gif') > -1) {
        // this.props.toggleToast(t("File type must be .jpg .jpeg .png."), true);
      } else if (acceptedFiles[0].size > 500 * 1024) {
        this.setState({
          showToast: false
        }, () => {
          // this.props.toggleToast('watermark picture maximum size 500kb', true);
        })
      } else {
        this.setState({
          setSaveDisabled: false,
        }, () => {
          this.handleDropImage(1, acceptedFiles[0]);
        })
      }
    });
  };

  //图片数据加载
  handleDropImage = (type, acceptedFiles, img) => {
    let fileUpload = '';
    let uploadedFiles = '';
    let setUpdateImageWarning = '';
    let imageAddWatermarkImg = ""
    if (img) {
      fileUpload = !img && <DropZone.FileUpload actionTitle={t("Add file")} actionHint="(Maximum size 500kb)" />;
      if (!img) {
        this.setState({
          showImageUploadBanner: true
        })
      }
      uploadedFiles = img && (
        <div className="addImage addImageBox">
          <Thumbnail
            size="small"
            alt=''
            source={PAGE_DOMAIN + img}
          />
        </div>
      );
      this.setState({
        imgButton: false,
        fileUpload: fileUpload,
        uploadedFiles: uploadedFiles,
        setUpdateImageWarning: "",
        showImageUploadBanner: false,
      });
    } else if (acceptedFiles) {
      const validImageTypes = ['image/jpg', 'image/jpeg', 'image/png'];
      const filesImg = acceptedFiles
      if (validImageTypes.indexOf(filesImg.type) >= 0) {
        let imageData = [];
        fileUpload = !filesImg && <DropZone.FileUpload actionTitle={t("Add file")} actionHint="(Maximum size 500kb)" />;
        if (!filesImg) {
          this.setState({
            showImageUploadBanner: true
          })
        }
        //开启FileReader
        let reader = new FileReader();
        reader.readAsDataURL(filesImg); //读取文件保存在result中
        reader.onload = (e) => {
          let getRes = e.target.result;//读取的结果在result中
          imageData.push(
            {
              'name': filesImg.name,
              'image': getRes,
              'type': filesImg.type,
            }
          );

          uploadedFiles = filesImg && (
            <div className="addHerpImage">
              <Thumbnail
                size="small"
                alt=""
                source={getRes}
              />
            </div>
          );
          imageAddWatermarkImg = getRes;

          this.setState({
            imgButton: false,
            fileUpload: fileUpload,
            uploadedFiles: uploadedFiles,
            imageAddWatermarkImg: imageAddWatermarkImg,
            setUpdateImageWarning: "",
            imageData: imageData,
            showImageUploadBanner: false,
          });
        }
      } else {
        fileUpload = <DropZone.FileUpload actionTitle={t("Add file")} actionHint="(Maximum size 500kb)" />;
        uploadedFiles = ''
        setUpdateImageWarning = <Banner
          title={t("The following images couldn't be uploaded:")}
          tone="critical"
          onDismiss={() => {
            this.setState({
              setUpdateImageWarning: null
            })
          }}
          action={{
            content: t("Contact us"),
            onAction: this.handleContactServiceShow
          }}
        >
          <List>
            <List.Item>
              {t("File type must be .jpg .jpeg .png.")}
            </List.Item>
          </List>
          <p></p>
        </Banner>
        this.setState({
          fileUpload: fileUpload,
          uploadedFiles: uploadedFiles,
          setUpdateImageWarning: setUpdateImageWarning,
          imageAddWatermarkImg: imageAddWatermarkImg,
          showImageUploadBanner: true,
        });
      }
    } else {
      fileUpload = <DropZone.FileUpload actionTitle={t("Add file")} actionHint="(Maximum size 500kb)" />;
      uploadedFiles = ''
      //如果提交的文件不是图片 就提醒报错
      if (type === 1) {
        setUpdateImageWarning = <Banner
          title={t("The following images couldn't be uploaded:")}
          tone="critical"
          onDismiss={() => {
            this.setState({
              setUpdateImageWarning: null
            })
          }}
          action={{
            content: t("Contact us"),
            onAction: this.handleContactServiceShow
          }}
        >
          <List>
            <List.Item>
              {t("File type must be .jpg .jpeg .png.")}
            </List.Item>
          </List>
        </Banner>
      }
      if (Number(this.state.imageAddWatermarkSwitch)) {
        this.setState({
          fileUpload: fileUpload,
          uploadedFiles: uploadedFiles,
          setUpdateImageWarning: setUpdateImageWarning,
          imageAddWatermarkImg: imageAddWatermarkImg,
          showImageUploadBanner: true
        });
      } else {
        this.setState({
          fileUpload: fileUpload,
          uploadedFiles: uploadedFiles,
          setUpdateImageWarning: setUpdateImageWarning,
          imageAddWatermarkImg: imageAddWatermarkImg,
        });
      }
    }
  }
  //删除图片
  deleteImage = () => {
    this.setState({
      files: '',
      imgButton: true,
      dataHasChange: true,
      showImageUploadBanner: true,
      imageAddWatermarkImg: ''
    }, () => {
      this.handleDropImage();
    });
  }

  //下拉框
  handleSelectChange = (e) => {
    this.setState({
      imageAddWatermarkPosition: e,
      setSaveDisabled: false,
    });
  }

  // 改版历史记录表tab
  handleTypeTabskeyChange = (e) => {
    this.setState({
      historyTabKey: e,
      historyTabLoading: true,
      historyTableData: [],
      historyQueryVal: '',
      hPage: 1,
      hPageSize: 10,
      progressCp: 0,
      progressAll: 0,
    }, () => {
      this.deleteTimeFunc(); // 删除订阅器
      this.getOptHistoryTable();
      this.getOptSchedule();
    })
  }

  // 历史记录搜索
  changeHistoryQueryVal = (val) => {
    this.setState({
      historyQueryVal: val,
    }, () => {
      this.getOptHistoryTable();
    })
  }

  // 历史表格 分页
  changeHitoryTablePageData = (e) => {
    this.setState({
      hPage: Number(e),
      historyTabLoading: true,
    }, () => {
      this.getOptHistoryTable();
    })
  }

  // 历史表格 页数
  changeHitoryTablePageSizeData = (e) => {
    this.setState({
      hPage: 1,
      hPageSize: Number(e),
      historyTabLoading: true,
    }, () => {
      this.getOptHistoryTable();
    })
  }

  // 历史表格 页码 失去焦点
  handleHistoryPageBlur = (e) => {
    this.setState({
      hPage: Number(e),
    }, () => {
      this.getOptHistoryTable();
    })
  }

  // 停止优化
  stopImageOptimize = () => {
    this.setState({
      stopLoading: true
    }, async () => {
      const res = await reqStopImageOptTask();
      if (res.ack === 1) {
        this.props.toggleToast(res.msg, false)
        this.setState({
          stopLoading: false,
          isShowManuallyBtnLoading: false,
          isInLoading: false,
          allOptType: false,
          isShowProgress: -1,
          progressCp: 0,
          progressAll: 0,
        }, () => {
          this.getOptHistoryTable();
          this.deleteTimeFunc();
        })
      } else {
        this.setState({
          stopLoading: false,
        })
        this.props.toggleToast(res.msg, true)
      }
    })
  }

  // 设置手动 批量数据
  setManuallyTableItemData = (data) => {
    this.setState({
      manuallyTableState: data,
    })
  }

  // 单个恢复 - 历史表格 集合和博客
  RestoreHitoryImageData = (data) => {
    let { historyTabKey, historyTableData } = this.state;
    let list = cloneDeep(historyTableData);
    list.forEach(item => {
      if (item['id'] === data['id'] && !Boolean(item['restoreLoadingId'].includes(data['id']))) {
        item['restoreLoadingId'].push(data['id']);
      }
    })
    this.setState({
      historyTableData: list
    }, async () => {
      let params = {
        data_type: historyTabKey + 1,
        data_list: [
          {
            data_id: historyTabKey === 1 ? data['coll_id'] : data['art_id'],
            restore_type: ''
          }
        ],
        handle_type: 2,
      }
      const res = await reqBatchRestore(params);
      list.forEach(item => {
        let indexId = item['restoreLoadingId'].indexOf(data['id']);
        if (item['id'] === data['id'] && indexId > -1) {
          item['restoreLoadingId'].splice(indexId, 1);
        }
      })
      if (res.ack === 1) {
        // this.setState({
        //   historyTableData: list
        // }, () => {
        this.props.toggleToast(res.msg, false);
        // this.getOptHistoryTable(false);
        setTimeout(() => {
          this.getOptSchedule();
        }, 3000)
        // })
      } else {
        this.setState({
          historyTableData: list
        }, () => {
          this.props.toggleToast(res.msg, true)
        })
      }
    })
  }

  // 产品 - 单个恢复 - 历史表格
  proRestoreHitoryImageData = (data) => {
    let { historyTabKey } = this.state;
    this.setState({
      restoreProId: data[0],
      batchLoading: true,
      isShowProgress: historyTabKey,
      optType: 'restore'
    }, async () => {
      let params = {
        data_type: 1,
        data_list: [{
          data_id: data[0],
        }],
        restore_type: '',
        handle_type: 2,
      }
      const res = await reqBatchRestore(params);
      if (res.ack === 1) {
        this.props.toggleToast(res.msg, false);
        setTimeout(() => {
          this.getOptSchedule();
        }, 3000)
      } else {
        this.setState({
          restoreProId: -1,
          batchLoading: false,
          isShowProgress: -1,
          optType: '',
        })
        this.props.toggleToast(res.msg, true);
      }
    })
  }

  // 批量恢复 - 历史表格
  BatchReHitoryImageData = (objData) => {
    let { historyTabKey, historyTableData } = this.state;
    this.setState({
      batchLoading: true,
      isShowProgress: historyTabKey,
      optType: 'restore'
    }, async () => {
      let dataList = [];
      objData[0].forEach(item => {
        historyTableData.forEach(data => {
          if (item === data['id'] && data['is_delete'] !== 1) {
            if (historyTabKey === 0) {
              dataList.push({
                data_id: data['prod_id'],
              })
            } else if (historyTabKey === 1) {
              dataList.push({
                data_id: data['coll_id'],
              })
            } else if (historyTabKey === 2) {
              dataList.push({
                data_id: data['art_id'],
                blog_id: data['blog_id'],
              })
            } else {
              dataList.push({
                data_id: data['id'],
              })
            }
          }
        })
      })
      let params = {
        data_type: historyTabKey + 1,
        data_list: dataList,
        restore_type: objData[1] ? 'all' : '',
        handle_type: 2,
      }
      if (dataList.length === 0) {
        // let tips = historyTabKey === 0 ? 'product' : historyTabKey === 1 ? 'collection' : 'blog';
        // this.props.toggleToast(`Select the correct state of the ${tips} data operation`, false);
        this.props.toggleToast(t("Please select items"), false);
        this.setState({
          batchLoading: false,
          isShowProgress: -1,
          optType: '',
        })
        return false;
      }
      const res = await reqBatchRestore(params);
      if (res.ack === 1) {
        this.props.toggleToast(res.msg, false);
        setTimeout(() => {
          this.getOptSchedule();
        }, 3000)
      } else {
        this.setState({
          batchLoading: false,
          isShowProgress: -1,
          optType: '',
        })
        this.props.toggleToast(res.msg, true);
      }
    })
  }

  // 批量重新优化 - 历史表格
  BatchOptHitoryImageData = (objData) => {
    let { historyTabKey, historyTableData } = this.state;
    this.setState({
      batchLoading: true,
      isShowProgress: historyTabKey,
      optType: 're-Optimize',
      optPageType: 0
    }, async () => {
      let dataList = [];
      objData[0].forEach(item => {
        historyTableData.forEach(data => {
          if (item === data['id'] && data['is_delete'] !== 1) {
            if (historyTabKey === 0) {
              dataList.push({
                data_id: data['prod_id'],
              })
            } else if (historyTabKey === 1) {
              dataList.push({
                data_id: data['coll_id'],
              })
            } else if (historyTabKey === 2) {
              dataList.push({
                data_id: data['art_id'],
                blog_id: data['blog_id'],
              })
            } else {
              dataList.push({
                data_id: data['id'],
              })
            }
          }
        })
      })
      let params = {
        data_type: historyTabKey + 1,
        data_list: dataList,
        re_opt_type: objData[1] ? 'all' : '',
        page_type: 0,
        handle_type: 2,
      }
      if (dataList.length === 0) {
        // let tips = historyTabKey === 0 ? 'product' : historyTabKey === 1 ? 'collection' : 'blog';
        // this.props.toggleToast(`Select the correct state of the ${tips} data operation`, false);
        this.props.toggleToast(t("Please select items"), false);
        this.setState({
          batchLoading: false,
          isShowProgress: -1,
          optType: '',
          optPageType: 0
        })
        return false;
      }
      const res = await reqBatchReOptimize(params);
      if (res.ack === 1) {
        this.props.toggleToast(res.msg, false);
        setTimeout(() => {
          this.getOptSchedule();
        }, 3000)
      } else {
        this.setState({
          batchLoading: false,
          isShowProgress: -1,
          optType: '',
        })
        this.props.toggleToast(res.msg, true);
      }
    })
  }

  // 保存设置
  saveSetData = async (type) => {
    let {
      auto_switch,
      is_default,
      image_opt,
      isShowImgCompression,
      isShowImgAltText,
      isShowImgFilename,
      productImg,
      ColImg,
      BlogImg,
      ConvertImg,
      AddWaterImg,
      imageAddWatermarkPosition,
      imageAddWatermarkSize,
      imageAddWatermarkOpacity,
      productAlt,
      ColAlt,
      BlogAlt,
      blankImgAlt,
      productFile,
      ColFile,
      BlogFile,
      proAltTag,
      colAltTag,
      blogAltTag,
      proFileTag,
      colFileTag,
      blogFileTag,
      imageAddWatermarkImg,
      imageData,
    } = this.state;
    // 判断是否自动开关还是设置保存
    let params = {};
    if (type === 'switch') {
      params = {
        auto_switch: Number(auto_switch),
      }
    } else {
      let tagActive = [];
      if (isShowImgAltText) {
        if (productAlt && !Boolean(proAltTag.replace(/[\s\n\u200B]/g, ""))) {
          tagActive.push('ProductAltFixTag');
        }
        if (ColAlt && !Boolean(colAltTag.replace(/[\s\n\u200B]/g, ""))) {
          tagActive.push('ColAltFixTag');
        }
        if (BlogAlt && !Boolean(blogAltTag.replace(/[\s\n\u200B]/g, ""))) {
          tagActive.push('BlogAltFixTag');
        }
      }
      if (isShowImgFilename) {
        if (productFile && !Boolean(proFileTag.replace(/[\s\n\u200B]/g, ""))) {
          tagActive.push('ProductFileFixTag');
        }
        if (ColFile && !Boolean(colFileTag.replace(/[\s\n\u200B]/g, ""))) {
          tagActive.push('ColFileFixTag');
        }
        if (BlogFile && !Boolean(blogFileTag.replace(/[\s\n\u200B]/g, ""))) {
          tagActive.push('BlogFileFixTag');
        }
      }
      this.setState({
        tagActive,
      })
      if (tagActive.length > 0) {
        // this.props.toggleToast('The input value cannot be empty', false);
        return false;
      }
      params = {
        alt_text: {
          blogs: Number(BlogAlt),
          switch: Number(isShowImgAltText),
          product: Number(Boolean(productAlt) ? productAlt : 0),
          blogs_rule: this.changeTagFormat('blog', blogAltTag),
          collection: Number(ColAlt),
          product_rule: this.changeTagFormat('product', proAltTag),
          blank_replace: Number(blankImgAlt),
          collection_rule: this.changeTagFormat('collection', colAltTag),
        },
        file_name: {
          blogs: Number(BlogFile),
          switch: Number(isShowImgFilename),
          product: Number(Boolean(productFile) ? productFile : 0),
          blogs_rule: this.changeTagFormat('blog', blogFileTag),
          collection: Number(ColFile),
          product_rule: this.changeTagFormat('product', proFileTag),
          collection_rule: this.changeTagFormat('collection', colFileTag)
        },
        is_default: is_default,
        auto_switch: Number(auto_switch),
        image_opt: {
          switch: Number(isShowImgCompression),
          product: Number(Boolean(productImg) ? productImg : 0),
          collection: Number(ColImg),
          blogs: Number(BlogImg),
          pngtojpg: Number(ConvertImg),
          quality: image_opt?.quality,
          watermark: {
            switch: Number(AddWaterImg),
            logo: imageAddWatermarkImg,
            // file_data: imageAddWatermarkImg,
            // file_name: Boolean(imageData) && imageData.length > 0 ? imageData[0].name : '',
            position: imageAddWatermarkPosition,
            image_height: Number(Number(imageAddWatermarkSize / 100).toFixed(2)),
            opacity: Number(imageAddWatermarkOpacity)
          }
        }
      }
      if (imageAddWatermarkImg.indexOf('base64') > -1) {
        params['image_opt']['watermark']['file_data'] = imageAddWatermarkImg;
        params['image_opt']['watermark']['file_name'] = Boolean(imageData) && imageData.length > 0 ? imageData[0].name : '';
        params['image_opt']['watermark']['logo'] = "";
      }
    }
    this.setState({
      setSaveLoading: true,
    })
    const res = await reqSaveSettings(params);
    if (res.ack === 1) {
      this.props.toggleToast(res.msg, false);
      this.setState({
        setSaveDisabled: true,
        setSaveLoading: false,
      }, () => {
        this.getProductStatistics(params['is_default'] ? true : false, null);
        setTimeout(() => {
          if (type !== 'switch') {
            this.setState({
              firstSetSheetActive: false,
            })
          }
        }, 1000)
      })
    } else {
      this.props.toggleToast(res.msg, true);
      this.setState({
        setSaveDisabled: false,
        setSaveLoading: false,
      })
    }

    return res;
  }

  //点击联系客服
  handleContactService = async (content) => {
    // window.Intercom('showMessages');
    // window.$crisp.push(["do", "chat:open"])
    try {
      if (content === "image compression") {
        // window.Intercom('showNewMessage', 'Hi,Can you increase the "image compression" quota for me?');
        // window.$crisp.push(["set", "message:text", ['Hi,Can you increase the "image compression" quota for me?']])
        showNewMessage('Hi,Can you increase the "image compression" quota for me?')
      } else if (content === "image on-page compression") {
        showNewMessage('Hi,Can you increase the "image compression" and “On-Page SEO Product” quota for me?')
      } else {
        showNewMessage();
      }
      const params = {
        'path': window.location.pathname,
        'content': content
      };
      await reqUpdateCustomerClick(params);
    } catch (e) {
      this.props.toggleToast(t("Try again later"), true);
    }
  }

  handleContactServiceShow = () => {
    try {
      showNewMessage()
    } catch (e) {
      this.props.toggleToast(t("Try again later"), true);
    }
  }

  // 关闭额度banner
  closeQuotaBanner = () => {
    this.setState({
      isShowQuotaImage: false,
    }, () => {
      try {
        sessionStorage.setItem('quotaBannerImage', 0);
      } catch (e) { }
    })
  }

  // 跳转升级额度
  jumpGetMore = () => {
    let { level } = this.state;
    if (level !== 3) {
      this.jumpPricing(true);
    } else {
      this.jumpSettings();
    }
  }

  // 关闭获取更多额度
  closeGetMoreQuota = () => {
    this.setState({
      isShowGetMore: false,
    }, () => {
      try {
        sessionStorage.setItem('getMoreQuotaBanner', 'close');
      } catch (e) { }
    })
  }

  // 返回
  goBack = () => {
    utils.routeJump(this, '/speedOpt')
  }

  // 关闭增量提示
  closeOverCharge = () => {
    this.setState({
      isShowOverCharge: false,
    })
  }

  // 跳转价格页
  jumpPricing = (isJump = true) => {
    let { level, impressionsUse, impressionsAll, exceedUse } = this.state;
    if (level === 1 && impressionsUse >= impressionsAll && !isJump) {
      this.props.handleShowGetMoreUsageModal('image', (impressionsUse + exceedUse));
    } else {
      utils.routeJump(this, "/plan")
    }
  }

  // 跳转设置页
  jumpSettings = () => {
    utils.routeJump(this, "/settings", null, 'overage');
  }

  // 跳转速度优化
  jumpSpeedUrl = () => {
    utils.routeJump(this, "/speedOpt/site-speedup")
  }

  // 关闭cw广告
  closeImageCwAdver = () => {
    this.setState({
      isShowCwAdverImage: false,
    }, () => {
      this.requestStateSet('cwAdverImageState', 1);
    })
  }

  // 关闭功能下架提示
  closeUnderFuncAdver = () => {
    this.setState({
      isShowUnderFunc: false,
    }, () => {
      try {
        sessionStorage.setItem('isShowUnderFunc', 'close');
      } catch (e) { }
    })
  }

  // 切换tab
  handleTabSelect = (selected) => {
    this.setState({
      selectedTab: selected,
    }, () => {
      switch (selected) {
        case 0:
          this.getProductStatistics(true, null);
          break;
        case 1:
          this.openManuallyOpt();
          break;
        default:
          break;
      }
    })
  }

  // 预览图片
  viewImageShow = (url) => {
    this.setState({
      imgUrl: url,
    })
  }

  // 关闭
  closeImageShow = () => {
    this.setState({
      imgUrl: ''
    })
  }

  // 上传图片
  handleUpdDrop = (_droppedFiles, acceptedFiles, rejectedUpdFiles) => {
    this.setState({
      updFiles: [...this.state.updFiles, ...acceptedFiles],
      rejectedUpdFiles: rejectedUpdFiles
    });
  }

  // 上传图片优化 - 转向other
  handleChangeRedirectSave = () => {
    //添加图片
    let { updFiles, isAddWatermark, impressionsUse, impressionsAll, exceedUse, exceedAll, level, usage_status } = this.state;
    if ((impressionsUse < impressionsAll) || (exceedUse < exceedAll) || usage_status === true) {
      this.setState({
        ActionUpdateLoading: true
      }, async () => {
        if (updFiles.length > 0) {
          //用户自动填写的数据
          let fileList = [];
          updFiles.forEach(file => {
            fileList.push({
              "filename": file.name,
              "type": file.type
            });
          });
          let params = {
            "file_list": fileList
          }
          const response = await reqGetPresignedUploadUrls(params)
          if (response.ack === 1) {
            let arr = response.data;
            let opt_cfg = {
              "pngtojpg": 0,
              "is_watermark": Number(isAddWatermark)
            }
            this.uploadS3(arr, updFiles, opt_cfg);
          } else {
            this.props.toggleToast(response.msg, true);
          }
        } else {
          this.setState({
            ActionUpdateLoading: false,
            updFiles: [],
            rejectedFiles: [],
          }, () => {
            this.props.toggleToast(t("haven't uploaded image"), true);
          });
        }
      });
    } else {
      this.setState({
        isShowUpload: false,
      }, () => {
        // 判断是否超额弹窗
        if (level !== 1 && [30002, 30003, 40002].includes(usage_status)) {
          if ([40002].includes(usage_status)) {
            this.props.openUpdateLimit();
          } else {
            this.props.openOverageModal({ type: 'image', onSuccess: () => this.getOptSchedule(true) });
          }
        } else {
          this.props.handleShowGetMoreUsageModal('image', (impressionsUse + exceedUse))
        }
      })
    }
  }

  // 上传s3
  uploadS3 = async (arr, files, opt_cfg) => {
    let fileArr = [];
    for (let i = 0; i < arr.length; i++) {
      try {
        let obj = arr[i];
        const response = await fetch(obj.upload_url, {
          method: 'PUT',
          body: files[obj.index],
          headers: {
            'Content-Type': files[obj.index].type
          }
        });
        if (response.ok) {
          fileArr.push({
            "file_path": obj.file_path,
            "data_id": obj.data_id,
            "filename": files[obj.index].name
          })
        }
      } catch (err) {
        this.props.toggleToast(err.message, true);
      }
    }

    let params = {
      file_paths: fileArr,
      opt_cfg,
    }
    const res = await reqUploadImagesOpt(params);
    if (res.ack === 1) {
      this.props.toggleToast(res.msg, false);
      this.setState({
        ActionUpdateLoading: false,
      }, () => {
        this.handleClearUpdFiles();
        this.handleTypeTabskeyChange(3);
      })
    } else {
      this.setState({
        ActionUpdateLoading: false,
      })
      this.props.toggleToast(res.msg, true);
    }
  }

  // 清空上传文件
  handleClearUpdFiles = () => {
    this.setState({
      updFiles: [],
      rejectedUpdFiles: [],
    })
  }

  // 移除上传文件
  handleRemoveFile = (index) => {
    this.setState({
      updFiles: this.state.updFiles.filter((_, i) => i !== index),
      rejectedUpdFiles: this.state.rejectedUpdFiles.filter((_, i) => i !== index),
    })
  }

  // 显示升级额度弹窗
  handleShowUpgradeMode = () => {
    let { level } = this.state;
    if (level === 1) {
      this.jumpPricing(false);
    } else {
      this.openManuallyOpt();
    }
  }

  // 设置优化状态
  setOptStatusChange = (e) => {
    this.setState({
      opt_status: e[0],
    }, () => {
      this.getManuallyData();
    })
  }
  // 设置shopify状态
  setProductStatusChange = (e) => {
    this.setState({
      shopify_status: e,
    }, () => {
      this.getManuallyData();
    })
  }

  // 关闭批量重新优化
  closeBulkReOpt = () => {
    this.setState({
      isShowBulkReOpt: false,
    })
  }

  // 关闭额度警告
  closeWarningQuotaTip = () => {
    this.setState({
      isShowWarningQuotaTip: false,
    })
  }

  // 判断升级模式
  handleUpgradeModeSet = () => {
    let { impressionsUse, exceedUse, level, usage_status } = this.state;
    if (level === 1) {
      this.jumpPricing(false);
    } else {
      // 判断是否超额弹窗
      if (level !== 1 && [30002, 30003, 40002].includes(usage_status)) {
        if ([40002].includes(usage_status)) {
          this.props.openUpdateLimit();
        } else {
          this.props.openOverageModal({ type: 'image', onSuccess: () => this.getOptSchedule(true) });
        }
      } else {
        this.props.handleShowGetMoreUsageModal('image', (impressionsUse + exceedUse));
      }
    }
  }

  // 发送请求
  requestStateSet = async (type, state) => {
    const params = {
      name: `${type}`,
      st: Number(state),
      exp: 0,
      type: `param`
    }
    const res = await reqSaveSwitchState(params);
    if (res.ack === 1) {
      let data = cloneDeep(this.props.public.publicInit.head_data?.switch_data)
      if (typeof data === 'boolean') {
        data = [];
      }
      data[`${type}`] = { "at": Math.floor(new Date().getTime() / 1000), "st": 1, "exp": 0 };
      this.props.setSwitchData(data);
    } else {
      // this.props.toggleToast(t("Try again later"), true);
    }
  }

  componentWillUnmount() {
    // 删除订阅器
    this.deleteTimeFunc();
    this.clearHistoryArr();
    this.setState = () => false;
  }

  render() {
    const {
      loadingPage,
      level,
      switchLoading,
      auto_switch,
      FirstSetActive,
      isShowManuallyModal,
      isShowImgCompression,
      isShowImgAltText,
      isShowImgFilename,
      isShowAutoState,
      is_default,
      total_saved_size,
      avg_saved_percent,
      impressionsUse,
      impressionsAll,
      impressionsProportion,
      freeQuota,
      ConvertImg,
      AddWaterImg,
      manuallyTabKey,
      manuallyTableRes,
      manuallyTableData,
      manuallyQueryVal,
      isShowManuallyLoading,
      mPage,
      mPageSize,
      image_opt,
      alt_text,
      file_name,
      hPage,
      hPageSize,
      historyQueryVal,
      historyTabKey,
      historyTableData,
      historyTabLoading,
      isImageCompression,
      isConvertImage,
      isAddWatermark,
      isImageAlttext,
      isImageFilename,
      historyTableRes,
      isShowManuallyBtnLoading,
      isShowProgress,
      progressCp,
      progressAll,
      optType,
      optPageType,
      batchLoading,
      historyyPre,
      historyNext,
      manuallyPre,
      manuallyNext,
      allOptType,
      exceedUse,
      exceedAll,
      is_capped,
      is_over_quota,
      historyTabLoadingShow,
      isShowMaxLimitState,
      un_opt_num,
      isShowCwAdverImage,
      isShowUnderFunc,
      impressionsPro,
      isShowSecTip,
      isShowPop,
      isGuideTip,
      imageSecTip,
      reduxLoading,
      handleTypePro,
      handleTypeCol,
      handleTypeBlog,
      usage_status,
      selectedTab,
      allQuotaUse,
      allQuotaAll,
      isShowImgProgress,
      imgUrl,
      isShowAutoStateBanner,
      updFiles,
      total_num,
      ActionUpdateLoading,
      opt_status,
      shopify_status,
      restoreProId,
      isShowBulkReOpt,
      isShowFileOpt,
      isLimitState,
      isShowWarningQuotaTip,
      isManuallyAction,
      auto_opt_num,
      adverData,
      isShowQuotaInfo,

    } = this.state;

    // 首次设置弹窗
    // 完成icon
    const checkIcon = <svg viewBox="0 0 20 20" className="Icon_Icon__uZZKy" width={20} height={20}><path fillRule="evenodd" d="M15.78 5.97a.75.75 0 0 1 0 1.06l-6.5 6.5a.75.75 0 0 1-1.06 0l-3.25-3.25a.75.75 0 1 1 1.06-1.06l2.72 2.72 5.97-5.97a.75.75 0 0 1 1.06 0Z"></path></svg>
    const firstModalTip = <Modal
      open={FirstSetActive}
      onClose={() => this.handleStateChange('FirstSetActive', false)}
      title={"✨ " + t("Get Started with Smarter Images in {{v1}} Seconds!", 60)}
      primaryAction={{
        content: t("Start Optimizing ({{v1}}s)", 60) + " →",
        onAction: this.openFirstSetUp,
      }}
    >
      <Modal.Section>
        <div className='setting_info'>
          <p>🚀{t("Automate your image workflow with SEOWILL!")}:</p>
          <span>{checkIcon} {t("Compress images without quality loss")}</span>
          <span>{checkIcon} {t("Boost SEO with auto-generated alt text")}</span>
          <span>{checkIcon} {t("Add watermarks & rename files effortlessly")}</span>
        </div>
      </Modal.Section>
    </Modal>

    // 功能下架提示
    const underFuncTipBlock = (isShowUnderFunc && false) && <Banner onDismiss={this.closeUnderFuncAdver}>
      <p>
        {t("To comply with Shopify's latest guidelines, the image format conversion feature (PNG to JPG) will be removed on January 22nd, 2025. Please")}&nbsp;
        <Button variant='plain' onClick={this.handleContactServiceShow}>{t("Contact us")}</Button>&nbsp;
        {t("for more information.")}
      </p>
    </Banner>

    // 顶部4个数据模块
    //进度条的颜色
    let ProgressBarClassName = "";
    let planTitle = "";
    let ComboByCardContent = "";
    if (level === 3) {
      planTitle = <span style={{ fontWeight: 700 }}>{t("Premium Plan")}</span>
      ComboByCardContent = <div className="Polaris-ProgressBar__Content">
        <label style={{ fontSize: "12px" }}>{t("Image Quota:")} {impressionsUse} / {impressionsAll}</label>
        <div className='ProgressBarGreen' title={impressionsPro + "%"}>
          <ProgressBar progress={impressionsAll === 0 ? 0 : impressionsPro} animated={false} size="small" />
        </div>
      </div>
    } else if (level === 2) {
      planTitle = <span style={{ fontWeight: 700 }}>{t("Pro Plan")}</span>
      ComboByCardContent = <div className="Polaris-ProgressBar__Content">
        <label style={{ fontSize: "12px" }}>{t("Image Quota:")}  {impressionsUse} / {impressionsAll}</label>
        <div className='ProgressBarGreen' title={impressionsPro + "%"}>
          <ProgressBar progress={impressionsAll === 0 ? 0 : impressionsPro} animated={false} size="small" />
        </div>
      </div>
    } else if (level === 1) {
      planTitle = <span style={{ fontWeight: 700 }}>{t("Free Plan")}</span>
      if (impressionsProportion >= 80) {
        ProgressBarClassName = "ProgressBarRed"
      } else {
        ProgressBarClassName = "ProgressBarGreen"
      }
      ComboByCardContent = <div className="Polaris-ProgressBar__Content">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItem: 'center' }}>
          <label style={{ fontSize: "12px" }}>{t("Image Quota:")}  {impressionsUse} / {impressionsAll}</label>
        </div>
        <div className={ProgressBarClassName} style={{ position: 'relative' }}>
          {(impressionsAll >= freeQuota || impressionsUse >= freeQuota) ?
            null : <div style={{ padding: '0.4rem', width: '100%', position: 'absolute', top: '0', left: '0.1rem', borderRadius: '1rem' }}></div>
          }
          <div style={{ position: 'relative', zIndex: '1' }} title={impressionsPro + "%"}>
            <ProgressBar progress={impressionsProportion} animated={false} size="small" />
          </div>
        </div>
      </div>
    }

    // 额度banner提示
    const quotaOption = Boolean(this.props.public.homeStreamData.other_options?.state) ? this.props.public.homeStreamData.other_options : {};
    const quotaBanner = false && (quotaOption.user_quota.images && this.state.isShowQuotaImage) ?
      <div className='quotaBannerNew'>
        <Card>
          <InlineGrid columns={['twoThirds', 'oneThird']}>
            <Text variant="headingMd" as="h2">{t("Special offer - Contact us for more free credits")}</Text>
            <div style={{ textAlign: 'right' }}><Button variant='plain' textAlign="left" onClick={() => this.closeQuotaBanner()}><Icon source={XSmallIcon} tone='base' /></Button></div>
          </InlineGrid>
          <div className='quota_main'>
            <div className='quota_item quota_gift_left'>
              <p>{t("As a thank you for your trust and support.")}</p>
              <p>{t("We offer free credits for you to continue using our services.")}</p>
              <Button onClick={() => this.handleContactService("image compression")} size='slim'>{t("Contact us for free quota")}</Button>
            </div>
            <div className='quota_item quota_gift_right'><Icon source={QuotaGiftIcon} tone='base' /></div>
          </div>
        </Card>
      </div> : null;

    const TopDataBlock = <div className='TopDataBlock'>
      <Card padding={0}>
        <div className='img_data_top'>
          <div className='img_data_item'>
            <Tooltip content={<div>
              <span>{t("The optimized and total image counts are based on the resources you selected in the")}</span>
              <Link removeUnderline onClick={() => this.openSettingCard(1)}>&nbsp;{t("Optimization settings")}.&nbsp;</Link>
              <span>{t("(Active products, collections, and blog posts)")}</span>
            </div>}>
              <p className='Every_Card_Text'>{t("Optimized Images")}</p>
            </Tooltip>
            <BlockStack gap={100}>
              <div className='img_data_text'>
                <p>{total_num - un_opt_num}</p>
                <span className='total_num'>{t("Total")}: {total_num}</span>
              </div>
              <div className='img_data_progress'>
                <ProgressBar progress={total_num === 0 ? 0 : Number(((total_num - un_opt_num) / total_num) * 100).toFixed(2)} animated={false} size="small" />
              </div>
              {
                (un_opt_num === 0 && total_num > 0) ?
                  <div className='img_completed_state'>
                    <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.99963 2.3999C11.0923 2.3999 13.6 4.9069 13.6002 7.99951C13.6002 11.0923 11.0924 13.6001 7.99963 13.6001C4.90702 13.5999 2.40002 11.0922 2.40002 7.99951C2.40024 4.90703 4.90715 2.40011 7.99963 2.3999ZM10.3717 6.38232C10.2014 6.21234 9.92582 6.21232 9.75549 6.38232L7.44592 8.69189L6.44495 7.69189C6.27454 7.52148 5.99817 7.52148 5.82776 7.69189C5.65753 7.86232 5.65741 8.13873 5.82776 8.30908L7.13733 9.61768C7.30769 9.78787 7.58317 9.78785 7.75354 9.61768L10.3717 6.99951C10.5421 6.8291 10.5421 6.55273 10.3717 6.38232Z" fill="#29845A" />
                    </svg>
                    <span>{t("All images optimized")}</span>
                  </div> : null
              }
            </BlockStack>
          </div>
          <div className='img_data_item'>
            <Tooltip content={t("The average percentage reduction in image memory size achieved by SEOWILL compression.")}>
              <p className='Every_Card_Text'>{t("Average Saved Percent")}</p>
            </Tooltip>
            <div className='img_data_text'>{parseInt(avg_saved_percent)}%</div>
          </div>
          <div className='img_data_item'>
            <Tooltip content={t("The total memory size reduction of all images compressed by SEOWILL")}>
              <p className='Every_Card_Text'>{t("Total Saved Space")}</p>
            </Tooltip>
            <div className='img_data_text' style={{ justifyContent: 'flex-start' }}>{`${total_saved_size || ""}`.slice(0, -2)} <span className='t_unit'>{`${total_saved_size || ""}`.slice(-2)}</span></div>
          </div>
        </div>
      </Card>
    </div>

    // 进度条面板
    const progressPanel = ((isShowAutoState && auto_opt_num > 0) || (!isShowAutoState && isShowProgress !== -1 && isShowProgress === historyTabKey)) && !isLimitState ? <Card padding={200}>
      <div className='opt_progress_hitory pro_panel'>
        <BlockStack gap={200}>
          <div className='flex_layout'>
            <div className='flex_layout auto_opt_tip_bar'>
              <img src='/imgs/ImageOpt/bulk_img.gif' alt="" />
              <Text variant="headingMd" as="h2" fontWeight="medium">
                {
                  optType === 'restore' ? t("Restoring in progress") + "..." : (optType === 're-Optimize' && optPageType === 0) ? t("Re-optimizing in progress") + "..." : t("Optimization in progress") + "..."
                }
                &nbsp;&nbsp;
                <span style={{ color: '#005BD3' }}>{(isShowAutoState ? auto_opt_num : (progressAll - progressCp)) || "-"}</span> {t("images remaining")}
              </Text>
              {/* <Spinner size='small' /> */}
              {!(isShowManuallyBtnLoading && !allOptType) ? null : <div style={{ marginLeft: 'auto' }}>
                <Button onClick={this.stopImageOptimize}>{t("Stop Now")}</Button>
              </div>}
            </div>
            {/* <span>{t("completed /all")}:&nbsp;&nbsp;{progressCp}/{progressAll}</span> */}
          </div>
          {/* {
            progressAll > 0 && <ProgressBar tone='primary' progress={Number(((progressCp / progressAll) * 100).toFixed(0))} animated={false} size='small' />
          } */}
        </BlockStack>
      </div>
    </Card> : null;

    // 进度状态成功
    const progressPanelSuccessTip = (isShowBulkReOpt && !isLimitState) && <Card>
      <div className='img_progress_tip' style={{ alignItems: 'center' }}>
        <div className='flex_layout img_progress_success'>
          <img src='/imgs/ImageOpt/img_success.png' alt="" />
          <Text variant="headingMd" as="h2" fontWeight="medium">{t("Great work! All images optimized")}</Text>
        </div>
        <div className='img_progress_close'>
          <Button variant='tertiary' size='micro' icon={XIcon} onClick={this.closeBulkReOpt}></Button>
        </div>
      </div>
    </Card>

    // 进度状态警告
    const progressPanelWarningTip = ((isShowAutoState || isManuallyAction) && isLimitState && usage_status !== true && isShowWarningQuotaTip) && <Card>
      <div className='img_progress_tip'>
        <div className='flex_layout img_progress_warning'>
          <img src='/imgs/ImageOpt/img_warning.png' alt="" />
          <div className='img_progress_warning_content'>
            <Text variant="headingMd" as="h2" fontWeight="medium">{t("Optimization paused — Image quota run out.")}</Text>
            <Button onClick={this.handleUpgradeModeSet}>{t("Upgrade to continue")}</Button>
          </div>
        </div>
        <div className='img_progress_close'>
          <Button variant='tertiary' size='micro' icon={XIcon} onClick={this.closeWarningQuotaTip}></Button>
        </div>
      </div>
    </Card>

    // // 获取额度banner
    // const getMoreBanner = (un_opt_num > remainQuota) && isShowGetMore ? <div className='get_show_quota'>
    //   <Card padding={300}>
    //     <div className='block_more_quota'>
    //       <div className='b_status'></div>
    //       <p>{t("To be optimized")}: <span>{un_opt_num}</span></p>
    //       <p>{t("Remaining available quota")}: <span>{remainQuota}</span></p>
    //       <p className='jump_text' onClick={this.jumpGetMore}>{t("Get more quota")}</p>
    //       <div className='close_more_icon' onClick={this.closeGetMoreQuota}>
    //         <Icon source={CancelSmallMinor} tone='base' />
    //       </div>
    //     </div>
    //   </Card>
    // </div> : null;

    // 功能顶部tabs
    const funcTopTabs = <div className='func_top_tabs'>
      <Tabs
        tabs={[
          {
            id: 'auto',
            content: t("Auto Optimization"),
          },
          {
            id: 'manual',
            content: t("Manual Optimization"),
          },
          {
            id: 'upload',
            content: t("Upload & Optimize"),
          }
        ]}
        selected={selectedTab}
        onSelect={(selected) => this.handleTabSelect(selected)}
      />
      <div>
        <Button onClick={() => this.openSettingCard(1)}>{t("Optimization Setting")}</Button>
      </div>
    </div>

    // 自动面板
    const AutoCardBox = <div className='image_setting'>
      <div className='img_switch'>
        <BlockStack gap={200}>
          <div className='flex_layout'>
            <div className='flex_layout'>
              <Text variant="headingMd" as="h2">{t("Auto Optimize Images")}</Text>
              <Badge tone={auto_switch ? 'success' : ''}>{auto_switch ? t("On") : t("Off")}</Badge>
            </div>
            <div className='flex_layout' style={{ position: "relative" }}>
              <Switch disabled={isShowManuallyBtnLoading || reduxLoading} onChange={() => this.autoOptAction()} checked={auto_switch} height={20} width={32} uncheckedIcon={false} checkedIcon={false} onColor="#303030" offColor="#888888" />
              {(switchLoading || reduxLoading) && <img className="Loading" src="/imgs/Image/loading.gif" style={{ width: '1.2rem', margin: '0 0.4rem' }} alt="loading" />}
              {
                ((isGuideTip || isShowSecTip) && !FirstSetActive && !auto_switch && imageSecTip) && <div className={`sec_tip popover_tip ${isShowPop ? "showPop" : ""}`}>
                  <div className="pop_main">
                    <div className="pop_child">
                      <p>{t("Activate automatically optimize images")}</p>
                      <div><Button variant="primary" onClick={() => this.autoOptAction()}>{t("Got it")}</Button></div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
          <div className='autoCard_tip'>
            <Text as="p" color="subdued">
              {t("Automatically optimize all new and existing images according to your")}
              &nbsp;<Button onClick={() => this.openSettingCard(1)} variant='plain' textAlign="left">{t("settings")}</Button>.&nbsp;
              {t("You can restore them within {{v1}} days in Optimization History.", 30)}
            </Text>
          </div>
        </BlockStack>
      </div>
      <div className='compare_opt_img'>
        <img onClick={() => this.viewImageShow('/imgs/other/compare_opt.png')} src='/imgs/other/compare_opt.png' alt='' />
      </div>
    </div>


    // 手动弹窗
    const manuallySetModal = <ManaullyModal
      is_default={is_default}
      tabKey={manuallyTabKey}
      tableRes={manuallyTableRes}
      tableData={manuallyTableData}
      queryValue={manuallyQueryVal}
      isShowManuallyModal={isShowManuallyModal}
      isShowImgCompression={isShowImgCompression}
      isShowImgAltText={isShowImgAltText}
      isShowImgFilename={isShowImgFilename}
      isShowAutoState={isShowAutoState}
      ConvertImg={ConvertImg}
      AddWaterImg={AddWaterImg}
      tableLoading={isShowManuallyLoading}
      page={mPage}
      pageSize={mPageSize}
      isImageCompression={isImageCompression}
      isConvertImage={isConvertImage}
      isAddWatermark={isAddWatermark}
      isImageAlttext={isImageAlttext}
      isImageFilename={isImageFilename}
      image_opt={image_opt}
      alt_text={alt_text}
      file_name={file_name}
      isShowProgress={isShowProgress}
      handleStateChange={this.handleStateChange}
      openSetupBox={this.openSetupBox}
      handleOptManaully={this.handleOptManaully}
      handleOptimize={this.handleOptimize}
      changeManuallyTab={this.changeManuallyTab}
      changeManuallyQueryVal={this.changeManuallyQueryVal}
      changeManuallyPageData={this.changeManuallyPageData}
      changeManuallyPageSizeData={this.changeManuallyPageSizeData}
      handlePageBlur={this.handleManuallyPageBlur}
      setManuallyTableItemData={this.setManuallyTableItemData}
      manuallyPre={manuallyPre}
      manuallyNext={manuallyNext}
      opt_status={opt_status}
      shopify_status={shopify_status}
      handleShowUpgradeMode={this.handleShowUpgradeMode}
      setOptStatusChange={this.setOptStatusChange}
      setProductStatusChange={this.setProductStatusChange}
      isShowFileOpt={isShowFileOpt}
    />

    // 手动面板
    const ManualOptBox = <div className='manual_opt_main'>
      <BlockStack gap={400}>
        {
          (auto_switch && isShowAutoStateBanner) ? <Banner
            title={t("Manual image optimization is unavailable.")}
            tone="warning"
            secondaryAction={{
              content: t("Disable Auto Optimization"),
              onAction: () => this.autoOptAction(),
              loading: switchLoading,
            }}
            onDismiss={() => { }}
          >
            <p>{t("To use manual image optimization, please turn off auto image optimization first.")}</p>
          </Banner> : null
        }
        <div className='manual_opt_content'>
          {manuallySetModal}
        </div>
      </BlockStack>
    </div>

    // 上传面板
    // 上传图片弹窗
    const fileUploadOpt = !updFiles.length && <DropZone.FileUpload actionTitle={t("Upload Image")} actionHint={t("Accepts .jpg, and .png")} />;
    const uploadedOptFiles = updFiles.length > 0 && (
      <BlockStack>
        <div className='opt_image_upload'>
          {updFiles.map((file, index) => (
            <div key={index} className='opt_image_upload_item'>
              <BlockStack gap={100}>
                <div className='opt_image_upload_close'>
                  <Button variant='tertiary' size='micro' disabled={ActionUpdateLoading} icon={XSmallIcon} onClick={(e) => {
                    e.stopPropagation();
                    this.handleRemoveFile(index);
                  }}></Button>
                </div>
                <Thumbnail
                  size="large"
                  alt={file.name}
                  source={window.URL.createObjectURL(file)}
                />
                <Text variant="bodySm" as="p">{file.name}</Text>
                <Text variant="bodySm" as="p">{changeBitInfo(file.size)}</Text>
              </BlockStack>
            </div>
          ))}
        </div>
      </BlockStack>
    );
    const UploadOptBox = <div className='upload_opt_box'>
      <BlockStack gap={400}>
        <div className='UploadOptBox_title'>
          <Text variant="headingMd" as="h2">{t("Upload Local Images to Optimize")}</Text>
          <Text as="p">
            {t("Upload and optimize images manually base on your")}
            &nbsp;
            <Button onClick={this.openSetupBox} variant='plain' textAlign="left">{t("settings")}.</Button>
            &nbsp;
            {t("You can restore them within {{v1}} days in Optimization History.", 30)}
          </Text>
        </div>
        <div className='manually_func_state'>
          <div className='m_set_item'>
            <span className='flex_layout'>
              <Text variant='headingMd' as="h2">{t("Image Compression")}</Text> <Badge tone={isImageCompression ? 'success' : ''}>{isImageCompression ? t("On") : t("Off")}</Badge>
            </span>
            <Button variant='tertiary' icon={ArrowRightIcon} onClick={this.openSetupBox}></Button>
          </div>
          <div className='m_set_item'>
            <span className='flex_layout'>
              <Text variant='headingMd' as="h2">{t("Add Image Watermarks")}</Text> <Badge tone={isAddWatermark ? 'success' : ''}>{isAddWatermark ? t("On") : t("Off")}</Badge>
            </span>
            <Button variant='tertiary' icon={ArrowRightIcon} onClick={this.openSetupBox}></Button>
          </div>
          {
            Boolean(isShowFileOpt) && <div className='m_set_item'>
              <span className='flex_layout'>
                <Text variant='headingMd' as="h2">{t("Optimize Image Filename")}</Text> <Badge tone={isImageFilename ? 'success' : ''}>{isImageFilename ? t("On") : t("Off")}</Badge>
              </span>
              <Button variant='tertiary' icon={ArrowRightIcon} onClick={this.openSetupBox}></Button>
            </div>
          }
        </div>
        <DropZone
          accept="image/png,image/jpeg,image/jpg"
          type="image"
          errorOverlayText="File type must be .jpg .jpeg .png."
          onDrop={this.handleUpdDrop}
        >
          {uploadedOptFiles}
          {fileUploadOpt}
        </DropZone>
        {
          updFiles.length > 0 && <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
            <Button disabled={ActionUpdateLoading} onClick={() => this.handleClearUpdFiles()}>{t("Cancel")}</Button>
            <Button variant='primary' loading={ActionUpdateLoading} onClick={this.handleChangeRedirectSave}>{t("Optimize")}</Button>
          </div>
        }
      </BlockStack>
    </div>

    // cw广告
    const cwAdver = (isShowCwAdverImage && adverData?.jump_url) &&
      <Card>
        <div
          className='cw_adver flex_layout speedopt_adver'
          data-cwill-report-name="recommend_app_exposure"
          data-cwill-report-attr={JSON.stringify({
            position: "speedopt_image_opt",
            recommend_app_id: `${adverData?.id}`,
            recommend_app_name: adverData?.app_name || '',
          })}
        >
          <span onClick={this.closeImageCwAdver}><Icon source={XIcon} tone="base" /></span>
          <div className='flex_layout'>
            <img src={adverData?.img_url} alt='' />
            <p className='cw_adver_desc'>
              {adverData?.desc}
            </p>
          </div>
          <Button onClick={() => {
            this.props.addClickNums(adverData?.id);
            utils.safeOpen(adverData?.jump_url);
            this.props.cwreportRecommendAppClick("speedopt_image_opt", adverData?.id, adverData?.app_name || '');
          }}>{t(adverData?.button_text)}</Button>
        </div>
      </Card>

    // 优化历史
    const OptimizationHistory = is_default === 0 && <div className='opt_history_box'>
      <BlockStack gap={600}>
        <Card padding={0}>
          <OptHistoryTable
            usage_status={usage_status}
            page={hPage}
            pageSize={hPageSize}
            queryValue={historyQueryVal}
            tabKey={historyTabKey}
            tableData={historyTableData}
            isShowAutoState={isShowAutoState}
            image_opt={image_opt}
            tableLoading={historyTabLoading}
            tableRes={historyTableRes}
            isShowProgress={isShowProgress}
            progressCp={progressCp}
            progressAll={progressAll}
            optType={optType}
            optPageType={optPageType}
            getEventAction={this.getEventAction}
            openUploadModal={this.openUploadModal}
            handleTypeTabskeyChange={this.handleTypeTabskeyChange}
            changeHistoryQueryVal={this.changeHistoryQueryVal}
            changeHitoryTablePageData={this.changeHitoryTablePageData}
            changeHitoryTablePageSizeData={this.changeHitoryTablePageSizeData}
            handlePageBlur={this.handleHistoryPageBlur}
            RestoreHitoryImageData={this.RestoreHitoryImageData}
            BatchReHitoryImageData={this.BatchReHitoryImageData}
            BatchOptHitoryImageData={this.BatchOptHitoryImageData}
            openSettingCard={this.openSettingCard}
            loading={batchLoading}
            impressionsUse={impressionsUse}
            impressionsAll={impressionsAll}
            level={level}
            exceedUse={exceedUse}
            exceedAll={exceedAll}
            is_capped={is_capped}
            is_over_quota={is_over_quota}
            isShowImgCompression={isShowImgCompression}
            historyyPre={historyyPre}
            historyNext={historyNext}
            isShowMaxLimitState={isShowMaxLimitState}
            handleTypePro={handleTypePro}
            handleTypeCol={handleTypeCol}
            handleTypeBlog={handleTypeBlog}
            restoreProId={restoreProId}
            handleShowGetMoreUsageModal={this.props.handleShowGetMoreUsageModal}
            openUpdateLimit={this.props.openUpdateLimit}
            proRestoreHitoryImageData={this.proRestoreHitoryImageData}
          />
        </Card>
      </BlockStack>
    </div>

    // // 是否增量banner
    // const OverchargeBanner = isShowOverCharge && <div className='overChargeBanner'>
    //   <Banner
    //     title={t("Remind: The quota limit has been reached")}
    //     tone="warning"
    //     onDismiss={this.closeOverCharge}
    //   >
    //     <p>
    //       {t("Cannot optimizate new images, because the usage quota has been reached. If you want to continue using it, you can turn on the overage")}
    //       <Button variant='plain' onClick={this.jumpSettings}>&nbsp;{t("settings")}.</Button>
    //     </p>
    //   </Banner>
    // </div>

    // // 是否达增量最大限度
    // const maxLimitBanner = isShowMaxLimitState && <div className='MaxLimitBanner'>
    //   <Banner
    //     title={t("Remind: The monthly spending cap has been reached")}
    //     tone="warning"
    //     onDismiss={this.closeOverCharge}
    //   >
    //     <p>
    //       {t("Cannot optimizate new images , because the monthly spending cap has been reached. If you want to continue using it, you can go to the")}
    //       <Button variant='plain' onClick={this.jumpSettings}>&nbsp;{t("settings")}&nbsp;</Button>
    //       {t("page to increase the spending cap.")}
    //     </p>
    //   </Banner>
    // </div>

    // 底部
    const FooterHelpBox = <FooterTrustHelp />

    // 最终页面
    const PageContentInfo = !loadingPage ? <Page
    // title={
    //   <div style={{ display: "flex", alignItems: "center" }}>
    //     {t("Image Optimization")}
    //   </div>
    // }
    // primaryAction={
    //   (impressionsUse < impressionsAll) || (exceedUse < exceedAll && level !== 3) || (exceedUse <= exceedAll && exceedAll >= 0 && exceedUse < 20000 && is_capped && level === 3) || (level === 3 && !isShowMaxLimitState) ? {
    //     content: t("Manually optimize"),
    //     onAction: this.openManuallyOpt,
    //     loading: ((isShowManuallyBtnLoading && !allOptType) || isInLoading),
    //     disabled: (auto_switch || initStateBtn || allOptType)
    //   } : {
    //     content: t("Upgrade plan"),
    //     onAction: this.jumpPricing,
    //   }
    // }
    // secondaryActions={is_default === 0 ? [
    //   {
    //     content: t("Upload images to optimize"),
    //     onAction: this.openUploadModal,
    //   }
    // ] : []}
    // backAction={{
    //   content: t("Image Optimization"),
    //   onAction: this.goBack,
    // }}
    >
      <title>SEOWILL - Image Optimization</title>
      <div className='Image_Opt_Info'>
        <div className='img_quota_info'>
          <div
            className={`pageButton ${(allQuotaUse / allQuotaAll) > 0.9 ? 'ProgressBarRed' : ''}`}
            style={{ top: !isShowQuotaInfo ? -20 : -30 }}
          >
            {
              isShowQuotaInfo ? <>
                <div className='flex_layout' style={{ gap: '2px' }}>
                  <span>{t("Image quota")}: {
                    reduxLoading || allQuotaAll === 0 ? "-" : `${allQuotaUse}/${allQuotaAll}`} </span>
                  {
                    (isShowImgProgress && Boolean(usage_status !== true)) && <span className='upgrade_icon flex_layout' onClick={this.handleUpgradeModeSet}>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3ZM10.5303 5.96973C10.2374 5.67683 9.76262 5.67683 9.46973 5.96973L6.96973 8.46973C6.67683 8.76262 6.67683 9.23738 6.96973 9.53027C7.26262 9.82317 7.73738 9.82317 8.03027 9.53027L9.25 8.31055V13.5C9.25 13.9142 9.58579 14.25 10 14.25C10.4142 14.25 10.75 13.9142 10.75 13.5V8.31055L11.9697 9.53027C12.2626 9.82317 12.7374 9.82317 13.0303 9.53027C13.3232 9.23738 13.3232 8.76262 13.0303 8.46973L10.5303 5.96973Z" fill="var(--color-primary)" />
                      </svg>
                    </span>
                  }
                </div>
                <ProgressBar progress={impressionsPro} size="small" />
              </> : <div style={{ width: '150px' }}><SkeletonBodyText lines={2} /></div>
            }
          </div>
        </div>
        <BlockStack gap={400}>
          {underFuncTipBlock}
          {/* {maxLimitBanner} */}
          {/* {OverchargeBanner} */}
          {quotaBanner}
          {TopDataBlock}
          {/* {getMoreBanner} */}
          <Card padding={0}>
            {funcTopTabs}
            {
              selectedTab === 0 ? <div className='AutoCardBox'>{AutoCardBox}</div> :
                selectedTab === 1 ? <div className='ManualOptBox'>{ManualOptBox}</div> :
                  selectedTab === 2 ? <div className='UploadOptBox'>{UploadOptBox}</div> : null
            }
          </Card>
          {cwAdver}
          {progressPanel}
          {progressPanelSuccessTip}
          {progressPanelWarningTip}
          {OptimizationHistory}
        </BlockStack>
        {FooterHelpBox}
      </div>
    </Page> : <SkeltonLoading />



    return (
      <div id="ImageOptimization">
        {PageContentInfo}

        {firstModalTip}
        {
          Boolean(imgUrl) && <ViewImage imgUrl={imgUrl} closeImageShow={this.closeImageShow} />
        }
      </div>
    );
  }
}

// 比特转换
function changeBitInfo(limit) {
  let size = "";
  if (limit < 1 * 1024 * 1024) {
    //小于0.1MB，则转化成KB 
    size = (limit / 1024).toFixed(2) + "KB"
  } else if (limit < 1 * 1024 * 1024 * 1024) {
    //小于0.1GB，则转化成MB 
    size = (limit / (1024 * 1024)).toFixed(2) + "MB"
  } else {
    //其他转化成GB 
    size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB"
  }
  return size;
}

const mapStateToProps = state => {
  return state
}
const mapDispatchToProps = dispatch => ({
  // 缓存自动开关状态
  setImageAutoSwitch(data) {
    dispatch(setImageAutoSwitchData(data));
  },

  // 设置自定义缓存
  setSwitchData(data) {
    dispatch(setSaveSwitchData(data))
  },

  // 判断是否页面第一次loading
  getPageDataRedux(data) {
    dispatch(setPageData(['ImageOptimization', data]));
  },
})
indexClass = connect(
  mapStateToProps,
  mapDispatchToProps
)(indexClass);

export default withRouter(indexClass);
0